(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["_ndev-card-selector"] && !Shopify.designMode) return;
  try {
    class NdevCardSelector extends BaseElement {
    init() {
      this._dropdownDirection = null;
      this._dropdownEl = null;
      this._render();
      this._onDocClick = (e) => {
        if (!this.contains(e.target)) {
          this._closeDropdown();
        }
      };
      this._onScrollResize = () => {
        this._positionDropdown();
      };
      document.addEventListener('click', this._onDocClick, true);
      window.addEventListener('scroll', this._onScrollResize, true);
      window.addEventListener('resize', this._onScrollResize);
    }

    dispose() {
      if (this._dropdownEl && this._dropdownEl.parentElement) {
        this._dropdownEl.parentElement.removeChild(this._dropdownEl);
        this._dropdownEl = null;
      }
      if (this._onDocClick) {
        document.removeEventListener('click', this._onDocClick, true);
        delete this._onDocClick;
      }
      if (this._onScrollResize) {
        window.removeEventListener('scroll', this._onScrollResize, true);
        window.removeEventListener('resize', this._onScrollResize);
        delete this._onScrollResize;
      }
      this.innerHTML = '';
    }

    _closeDropdown() {
      const trigger = this.querySelector('.ndev-card-switcher__select-trigger.is-open');
      const dropdown = this._dropdownEl;
      if (!trigger || !dropdown || !trigger.classList.contains('is-open')) return;
      trigger.classList.remove('is-open');
      dropdown.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      dropdown.style.left = '';
      dropdown.style.top = '';
      dropdown.style.bottom = '';
      dropdown.style.width = '';
      dropdown.style.maxHeight = '';
      const wrapper = this.querySelector('.ndev-card-switcher__select');
      if (wrapper && dropdown.parentElement !== wrapper) {
        wrapper.appendChild(dropdown);
      }
      this._dropdownDirection = null;
    }

    _getDropdownDirection(rect, gap) {
      const spaceBelow = window.innerHeight - rect.bottom - gap;
      const spaceAbove = rect.top - gap;
      return (spaceBelow >= 120 || spaceBelow >= spaceAbove) ? 'below' : 'above';
    }

    _positionDropdown() {
      const trigger = this.querySelector('.ndev-card-switcher__select-trigger');
      const dropdown = this._dropdownEl;
      if (!trigger || !dropdown) return;
      if (!trigger.classList.contains('is-open')) return;

      const rect = trigger.getBoundingClientRect();
      const gap = 4;

      dropdown.style.left = rect.left + 'px';
      dropdown.style.width = rect.width + 'px';
      dropdown.style.maxHeight = '';
      dropdown.style.top = '';
      dropdown.style.bottom = '';

      const spaceBelow = window.innerHeight - rect.bottom - gap;
      const spaceAbove = rect.top - gap;

      if (!this._dropdownDirection) {
        this._dropdownDirection = this._getDropdownDirection(rect, gap);
      }

      if (this._dropdownDirection === 'below') {
        dropdown.style.top = rect.bottom + gap + 'px';
        if (spaceBelow < 240) {
          dropdown.style.maxHeight = Math.max(spaceBelow, 80) + 'px';
        }
      } else {
        dropdown.style.bottom = window.innerHeight - rect.top + gap + 'px';
        if (spaceAbove < 240) {
          dropdown.style.maxHeight = Math.max(spaceAbove, 80) + 'px';
        }
      }
    }

    _render() {
      this.innerHTML = '';
      const labels = JSON.parse(this.dataset.labels || '[]');
      const type = this.dataset.type || 'button';
      const colors = JSON.parse(this.dataset.colors || '[]');
      const active = parseInt(this.dataset.active, 10) || 0;

      const container = document.createElement('div');
      container.className = 'ndev-card-switcher__selector';

      if (type === 'select') {
        const wrapper = document.createElement('div');
        wrapper.className = 'ndev-card-switcher__select';

        const trigger = document.createElement('div');
        trigger.className = 'ndev-card-switcher__select-trigger';
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('tabindex', '0');
        trigger.setAttribute('aria-haspopup', 'listbox');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('data-option-item', '');

        const triggerText = document.createElement('span');
        triggerText.className = 'ndev-card-switcher__select-trigger-text';
        triggerText.textContent = labels[active] || 'Please select';
        trigger.appendChild(triggerText);

        const icon = document.createElement('span');
        icon.className = 'ndev-card-switcher__select-icon';
        icon.innerHTML = '<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';
        trigger.appendChild(icon);

        const dropdown = document.createElement('div');
        dropdown.className = 'ndev-card-switcher__select-dropdown';
        dropdown.setAttribute('role', 'listbox');

        const optionsList = document.createElement('ul');
        optionsList.className = 'ndev-card-switcher__select-options';

        for (let i = 0; i < labels.length; i++) {
          const option = document.createElement('li');
          option.className = 'ndev-card-switcher__select-option' + (i === active ? ' is-selected' : '');
          option.setAttribute('role', 'option');
          option.setAttribute('data-value', String(i));
          option.setAttribute('data-label', labels[i]);
          option.textContent = labels[i];
          optionsList.appendChild(option);
        }
        dropdown.appendChild(optionsList);

        wrapper.appendChild(trigger);
        wrapper.appendChild(dropdown);
        this._dropdownEl = dropdown;

        trigger.addEventListener('click', (e) => {
          e.stopPropagation();
          const wasOpen = trigger.classList.contains('is-open');
          this._closeDropdown();
          if (wasOpen) return;
          trigger.classList.add('is-open');
          dropdown.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          document.body.appendChild(dropdown);
          this._positionDropdown();
        });

        optionsList.addEventListener('click', (e) => {
          const opt = e.target.closest('.ndev-card-switcher__select-option');
          if (!opt) return;
          const index = Number(opt.getAttribute('data-value'));
          const label = opt.getAttribute('data-label') || '';

          optionsList.querySelectorAll('.ndev-card-switcher__select-option').forEach(function (o) {
            o.classList.remove('is-selected');
          });
          opt.classList.add('is-selected');
          triggerText.textContent = label;

          this._closeDropdown();
          this.dispatchEvent(new CustomEvent('ndev:select', { bubbles: true, detail: { index: index } }));
        });

        container.appendChild(wrapper);
      } else if (type === 'swatch') {
        for (let i = 0; i < labels.length; i++) {
          const swatch = document.createElement('button');
          swatch.className = 'ndev-card-switcher__swatch' + (i === active ? ' is-active' : '');
          swatch.setAttribute('data-option-item', '');
          swatch.setAttribute('type', 'button');
          swatch.setAttribute('title', labels[i]);
          swatch.setAttribute('aria-label', labels[i]);
          swatch.style.background = colors[i] || 'transparent';
          const idx = i;
          swatch.addEventListener('click', function () {
            this.dispatchEvent(new CustomEvent('ndev:select', { bubbles: true, detail: { index: idx } }));
          }.bind(this));
          container.appendChild(swatch);
        }
      } else {
        for (let i = 0; i < labels.length; i++) {
          const btn = document.createElement('button');
          btn.className = 'ndev-card-switcher__button' + (i === active ? ' is-active' : '');
          btn.setAttribute('data-option-item', '');
          btn.setAttribute('type', 'button');
          btn.textContent = labels[i];
          const idx = i;
          btn.addEventListener('click', function () {
            this.dispatchEvent(new CustomEvent('ndev:select', { bubbles: true, detail: { index: idx } }));
          }.bind(this));
          container.appendChild(btn);
        }
      }
      this.appendChild(container);
    }

    setActive(index) {
      this.dataset.active = String(index);

      const items = this.querySelectorAll('[data-option-item]');
      for (let i = 0; i < items.length; i++) {
        items[i].classList.toggle('is-active', i === index);
      }

      const triggerText = this.querySelector('.ndev-card-switcher__select-trigger-text');
      if (triggerText) {
        const selectedOption = this.querySelector('.ndev-card-switcher__select-option[data-value="' + index + '"]');
        if (selectedOption) {
          this.querySelectorAll('.ndev-card-switcher__select-option').forEach(function (o) {
            o.classList.remove('is-selected');
          });
          selectedOption.classList.add('is-selected');
          triggerText.textContent = selectedOption.getAttribute('data-label') || String(index);
        }
      }

      this._closeDropdown();
    }
  }

  if (!customElements.get('ndev-card-selector')) {
    customElements.define('ndev-card-selector', NdevCardSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["_ndev-page-banner-button-assets"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'page-banner-video-popup';
    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(btnEl) {
      const controller = btnEl ? controllers.get(btnEl) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (btnEl) controllers.delete(btnEl);
    }

    function initOne(btnEl) {
      if (!btnEl || btnEl.dataset.actionType !== 'popup_video') return;

      destroyOne(btnEl);

      const dialogEl = btnEl.nextElementSibling;
      if (!dialogEl || dialogEl.tagName !== 'DIALOG') return;

      let isClosing = false;
      let resizeFrame = null;
      let returnFocus = null;
      const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      function getVideos() {
        return Array.prototype.slice.call(dialogEl.querySelectorAll('video'));
      }

      function getVisibleVideo() {
        const selector = window.matchMedia('(max-width: 1023px)').matches
          ? '.show-mb video'
          : '.show-pc video';
        return dialogEl.querySelector(selector) || dialogEl.querySelector('video');
      }

      function pauseAllVideos() {
        getVideos().forEach(function (video) {
          try { video.pause(); } catch (e) {}
        });
      }

      function playVisibleVideo() {
        if (!dialogEl.open || document.hidden) return;
        const activeVideo = getVisibleVideo();
        getVideos().forEach(function (video) {
          if (video !== activeVideo) {
            try { video.pause(); } catch (e) {}
          }
        });
        if (!activeVideo) return;
        if (activeVideo.preload === 'none' && activeVideo.readyState === 0) {
          try { activeVideo.load(); } catch (e) {}
        }
        activeVideo.muted = false;
        try {
          const playPromise = activeVideo.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
        } catch (e) {}
      }

      function finishClose() {
        dialogEl.classList.remove('closing');
        isClosing = false;
        if (dialogEl.open) dialogEl.close();
        if (returnFocus && returnFocus.isConnected) returnFocus.focus();
      }

      function closeWithAnimation() {
        if (isClosing || !dialogEl.open) return;
        isClosing = true;

        pauseAllVideos();

        if (motionQuery.matches) {
          finishClose();
          return;
        }

        dialogEl.classList.add('closing');
        dialogEl.addEventListener('animationend', function handler(e) {
          if (e.target !== dialogEl) return;
          dialogEl.removeEventListener('animationend', handler);
          finishClose();
        });
      }

      function handleBtnClick(e) {
        e.preventDefault();
        e.stopPropagation();
        returnFocus = btnEl;
        dialogEl.showModal();
        playVisibleVideo();
      }

      function handleDialogClick(e) {
        const rect = dialogEl.getBoundingClientRect();
        if (e.clientY < rect.top || e.clientY > rect.bottom ||
            e.clientX < rect.left || e.clientX > rect.right) {
          closeWithAnimation();
        }
      }

      function handleHide(e) {
        e.preventDefault();
        closeWithAnimation();
      }

      function handleCancel(e) {
        e.preventDefault();
        closeWithAnimation();
      }

      function handleResize() {
        if (resizeFrame) cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(playVisibleVideo);
      }

      function handleVisibility() {
        if (document.hidden) pauseAllVideos();
        else playVisibleVideo();
      }

      function handleClose() {
        pauseAllVideos();
        if (returnFocus && returnFocus.isConnected) returnFocus.focus();
      }

      btnEl.addEventListener('click', handleBtnClick);
      dialogEl.addEventListener('click', handleDialogClick);
      dialogEl.addEventListener('hide', handleHide);
      dialogEl.addEventListener('cancel', handleCancel);
      dialogEl.addEventListener('close', handleClose);
      window.addEventListener('resize', handleResize);
      document.addEventListener('visibilitychange', handleVisibility);

      controllers.set(btnEl, {
        destroy: function () {
          if (resizeFrame) cancelAnimationFrame(resizeFrame);
          pauseAllVideos();
          btnEl.removeEventListener('click', handleBtnClick);
          dialogEl.removeEventListener('click', handleDialogClick);
          dialogEl.removeEventListener('hide', handleHide);
          dialogEl.removeEventListener('cancel', handleCancel);
          dialogEl.removeEventListener('close', handleClose);
          window.removeEventListener('resize', handleResize);
          document.removeEventListener('visibilitychange', handleVisibility);
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll('[data-action-type="popup_video"]');
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll('[data-action-type="popup_video"]');
      for (let i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lulu-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
    const SELECTOR = '[is="ui-dialog"]';
    const MODULE = 'lulu-dialog';

    const ensure = () => {
      if (!document.querySelector(SELECTOR)) return;
      import(MODULE).catch(() => {});
    };

    ensure();
    document.addEventListener('shopify:section:load', ensure);
    document.addEventListener('shopify:block:select', ensure);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lulu-tab"] && !Shopify.designMode) return;
  try {
    (() => {
    const SELECTOR = 'ui-tab';
    const MODULE = 'lulu-tab';

    const ensure = () => {
      if (!document.querySelector(SELECTOR)) return;
      import(MODULE).catch(() => {});
    };

    ensure();
    document.addEventListener('shopify:section:load', ensure);
    document.addEventListener('shopify:block:select', ensure);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-asset-frame-sequence"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ndev-asset-frame-sequence')) {
    class NdevAssetFrameSequence extends BaseElement {
      init() {
        this.canvas = this.querySelector('canvas');
        this.ctx = this.canvas ? this.canvas.getContext('2d') : null;
        if (!this.canvas || !this.ctx) return;

        this.frameCount = this.readNumber('frame-count', 1);
        this.startIndex = this.readNumber('start-index', 0);
        this.padLength = this.readNumber('pad-length', 3);
        this.reducedMotionKeyframes = this.readReducedMotionKeyframes('reduced-motion-keyframes');
        this.reducedMotionFrameIndexes = this.reducedMotionKeyframes.map((keyframe) => keyframe.frameIndex);
        this.extension = this.getAttribute('extension') || 'webp';
        this.progressEvent = this.getAttribute('progress-event') || 'ndev-frame-sequence-progress';
        this.sourceSelector = this.getAttribute('progress-source-selector') || 'body';
        this.lookahead = this.readNumber('lookahead', 8);
        this.trailingLookback = Math.min(6, Math.max(2, Math.ceil(this.lookahead / 2)));
        this.maxConcurrent = this.readNumber('max-concurrent', 3);
        this.mode = '';
        this.cache = new Map();
        this.activeLoads = 0;
        this.touch = 0;
        this.raf = 0;
        this.resizeRaf = 0;
        this.scrollIdleTimer = 0;
        this.isScrolling = false;
        this.currentProgress = 0;
        this.targetIndex = 0;
        this.lastRequestedIndex = 0;
        this.lastRenderedIndex = -1;
        this.direction = 1;
        this.generation = 0;
        this.canvasReady = false;
        this.loadingEnabled = false;
        this.hasEnteredLoadRange = false;
        this.loadObserver = null;
        this._mq = window.matchMedia('(min-width: 1024px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onProgress = this.handleProgress.bind(this);
        this.onResize = this.requestResize.bind(this);
        this.onModeChange = this.handleEnvironmentChange.bind(this);
        this.onLoadIntersection = this.handleLoadIntersection.bind(this);

        this.source = this.closest(this.sourceSelector) || document.querySelector(this.sourceSelector);
        if (this.source) {
          this.source.addEventListener(this.progressEvent, this.onProgress);
        }
        window.addEventListener('resize', this.onResize, { passive: true });
        if (this._mq && this._mq.addEventListener) {
          this._mq.addEventListener('change', this.onModeChange);
        } else if (this._mq && this._mq.addListener) {
          this._mq.addListener(this.onModeChange);
        }
        if (this.reducedMotion.addEventListener) {
          this.reducedMotion.addEventListener('change', this.onModeChange);
        } else if (this.reducedMotion.addListener) {
          this.reducedMotion.addListener(this.onModeChange);
        }

        this.resetForCurrentMode();
        this.setupLoadingGate();
      }

      dispose() {
        if (this.source) {
          this.source.removeEventListener(this.progressEvent, this.onProgress);
        }
        window.removeEventListener('resize', this.onResize);
        if (this._mq && this._mq.removeEventListener) {
          this._mq.removeEventListener('change', this.onModeChange);
        } else if (this._mq && this._mq.removeListener) {
          this._mq.removeListener(this.onModeChange);
        }
        if (this.reducedMotion && this.reducedMotion.removeEventListener) {
          this.reducedMotion.removeEventListener('change', this.onModeChange);
        } else if (this.reducedMotion && this.reducedMotion.removeListener) {
          this.reducedMotion.removeListener(this.onModeChange);
        }
        if (this.raf) cancelAnimationFrame(this.raf);
        if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf);
        if (this.scrollIdleTimer) clearTimeout(this.scrollIdleTimer);
        this.disconnectLoadObserver();
        this.raf = 0;
        this.resizeRaf = 0;
        this.scrollIdleTimer = 0;
        this.clearCache();
      }

      setupLoadingGate() {
        if (!this.canLoadFrames() || this.hasEnteredLoadRange || this.loadObserver) return;

        if (!('IntersectionObserver' in window)) {
          this.hasEnteredLoadRange = true;
          this.enableLoading();
          return;
        }

        this.loadObserver = new IntersectionObserver(this.onLoadIntersection, {
          rootMargin: '100% 0px',
          threshold: 0,
        });
        this.loadObserver.observe(this);
      }

      handleLoadIntersection(entries) {
        const entry = entries[0];
        if (!entry || !entry.isIntersecting) return;
        this.hasEnteredLoadRange = true;
        this.disconnectLoadObserver();
        this.enableLoading();
      }

      disconnectLoadObserver() {
        if (!this.loadObserver) return;
        this.loadObserver.disconnect();
        this.loadObserver = null;
      }

      enableLoading() {
        if (this.loadingEnabled || !this.canLoadFrames()) return;
        this.loadingEnabled = true;
        this.scheduleFrame(this.getFrameIndex(this.currentProgress));
      }

      handleEnvironmentChange() {
        this.loadingEnabled = this.hasEnteredLoadRange && this.canLoadFrames();
        this.resetForCurrentMode();

        if (!this.canLoadFrames()) {
          this.disconnectLoadObserver();
        } else if (!this.hasEnteredLoadRange) {
          this.setupLoadingGate();
        }
      }

      readNumber(key, fallback) {
        const value = Number(this.getAttribute(key));
        return Number.isFinite(value) ? value : fallback;
      }

      readReducedMotionKeyframes(key) {
        const maxIndex = Math.max(0, this.frameCount - 1);
        const keyframes = (this.getAttribute(key) || '')
          .split(',')
          .map((entry) => {
            const [progressValue, frameValue] = entry.split(':');
            const progress = Number(progressValue);
            const frameIndex = Number(frameValue);
            if (!Number.isFinite(progress) || !Number.isFinite(frameIndex)) return null;
            return {
              progress: this.clamp(progress, 0, 1),
              frameIndex: this.clamp(Math.round(frameIndex), 0, maxIndex),
            };
          })
          .filter(Boolean)
          .sort((a, b) => a.progress - b.progress);

        return keyframes.filter((keyframe, index) => index === 0 || keyframe.progress !== keyframes[index - 1].progress);
      }

      canLoadFrames() {
        return !this.reducedMotion.matches || this.reducedMotionFrameIndexes.length > 0;
      }

      getFrameIndex(progress) {
        const maxIndex = Math.max(0, this.frameCount - 1);
        if (!this.reducedMotion.matches || !this.reducedMotionFrameIndexes.length) {
          return Math.round(progress * maxIndex);
        }

        let frameIndex = this.reducedMotionKeyframes[0].frameIndex;
        this.reducedMotionKeyframes.forEach((keyframe) => {
          if (progress >= keyframe.progress) frameIndex = keyframe.frameIndex;
        });
        return frameIndex;
      }

      getMode() {
        const isDesktop = this._mq ? this._mq.matches : window.matchMedia('(min-width: 1024px)').matches;
        return isDesktop ? 'pc' : 'mb';
      }

      getModeConfig() {
        const mode = this.getMode();
        const isPc = mode === 'pc';
        return {
          mode,
          prefix: isPc ? this.getAttribute('pc-prefix') : this.getAttribute('mb-prefix'),
          template: isPc ? this.getAttribute('pc-url-template') : this.getAttribute('mb-url-template'),
          width: this.readNumber(isPc ? 'pc-width' : 'mb-width', 1),
          height: this.readNumber(isPc ? 'pc-height' : 'mb-height', 1),
          cacheSize: this.readNumber(isPc ? 'pc-cache-size' : 'mb-cache-size', isPc ? 14 : 32),
        };
      }

      resetForCurrentMode() {
        this.generation += 1;
        this.config = this.getModeConfig();
        this.mode = this.config.mode;
        this.clearCache();
        this.activeLoads = 0;
        if (this.scrollIdleTimer) clearTimeout(this.scrollIdleTimer);
        this.scrollIdleTimer = 0;
        this.isScrolling = false;
        this.lastRenderedIndex = -1;
        this.canvasReady = false;
        this.classList.remove('is-canvas-ready');
        this.resizeCanvas();
        if (this.loadingEnabled) this.scheduleFrame(this.getFrameIndex(this.currentProgress));
      }

      requestResize() {
        if (this.resizeRaf) return;
        this.resizeRaf = requestAnimationFrame(() => {
          this.resizeRaf = 0;
          this.resizeCanvas();
          this.redrawCurrentFrame();
        });
      }

      resizeCanvas() {
        const rect = this.getBoundingClientRect();
        const width = Math.max(1, rect.width || this.config.width);
        const height = Math.max(1, rect.height || this.config.height);
        const scale = Math.min(
          window.devicePixelRatio || 1,
          2,
          this.config.width / width,
          this.config.height / height
        );
        const canvasWidth = Math.max(1, Math.ceil(width * scale));
        const canvasHeight = Math.max(1, Math.ceil(height * scale));

        if (this.canvas.width !== canvasWidth || this.canvas.height !== canvasHeight) {
          this.canvas.width = canvasWidth;
          this.canvas.height = canvasHeight;
        }
      }

      handleProgress(event) {
        const detail = event.detail || {};
        const progress = this.clamp(Number(detail.progress) || 0, 0, 1);
        this.currentProgress = progress;

        if (!this.loadingEnabled && this.canLoadFrames() && detail.active) {
          this.hasEnteredLoadRange = true;
          this.disconnectLoadObserver();
          this.enableLoading();
        }
        if (!this.loadingEnabled) return;

        const index = this.getFrameIndex(progress);
        if (this.reducedMotion.matches && index === this.targetIndex && this.cache.has(index)) return;
        if (!this.reducedMotion.matches) this.markScrolling();
        this.scheduleFrame(index);
      }

      markScrolling() {
        this.isScrolling = true;
        if (this.scrollIdleTimer) clearTimeout(this.scrollIdleTimer);
        this.scrollIdleTimer = setTimeout(() => {
          this.isScrolling = false;
          this.scrollIdleTimer = 0;
          this.dropIdleQueuedFrames();
          this.drawTargetFrame();
        }, 160);
      }

      scheduleFrame(index) {
        if (!this.loadingEnabled) return;
        const target = this.clamp(Math.round(index), 0, Math.max(0, this.frameCount - 1));
        this.direction = target >= this.lastRequestedIndex ? 1 : -1;
        this.lastRequestedIndex = target;
        this.targetIndex = target;
        this.trimQueuedFrames();
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          this.updateFrame();
        });
      }

      updateFrame() {
        const generation = this.generation;
        this.queueFrame(this.targetIndex, generation, 0).then((record) => {
          if (generation === this.generation && record && record.index === this.targetIndex) {
            this.drawRecord(record);
            this.preloadAround(this.targetIndex, generation);
          }
        });
        this.drawTargetFrame();
        if (!this.isTargetDecoded() && this.isScrolling) this.drawNearestFrame();
        this.preloadAround(this.targetIndex, generation);
      }

      preloadAround(index, generation) {
        if (this.reducedMotion.matches) {
          this.reducedMotionFrameIndexes.forEach((frameIndex, stepIndex) => {
            if (frameIndex !== index) this.queueFrame(frameIndex, generation, 20 + stepIndex);
          });
          this.trimQueuedFrames();
          return;
        }

        for (let offset = 1; offset <= this.lookahead; offset += 1) {
          this.queueFrame(index + offset * this.direction, generation, 10 + offset);
        }
        for (let offset = 1; offset <= this.trailingLookback; offset += 1) {
          this.queueFrame(index - offset * this.direction, generation, 30 + offset);
        }
        this.trimQueuedFrames();
      }

      queueFrame(index, generation, priority) {
        if (index < 0 || index >= this.frameCount) return Promise.resolve(null);

        const cached = this.cache.get(index);
        if (cached) {
          cached.touched = ++this.touch;
          cached.priority = Math.min(cached.priority, priority);
          this.pumpQueue(generation);
          return cached.promise;
        }

        let resolveRecord;
        const record = {
          index,
          image: null,
          decoded: false,
          loading: false,
          priority,
          touched: ++this.touch,
          promise: new Promise((resolve) => {
            resolveRecord = resolve;
          }),
          resolve: resolveRecord,
        };

        this.cache.set(index, record);
        this.trimQueuedFrames();
        this.pumpQueue(generation);
        return record.promise;
      }

      pumpQueue(generation) {
        if (generation !== this.generation) return;

        while (this.activeLoads < this.maxConcurrent) {
          const record = this.nextQueuedRecord();
          if (!record) return;
          this.startLoad(record, generation);
        }
      }

      nextQueuedRecord() {
        const records = Array.from(this.cache.values())
          .filter((record) => !record.decoded && !record.loading)
          .sort((a, b) => {
            if (a.priority !== b.priority) return a.priority - b.priority;
            return Math.abs(a.index - this.targetIndex) - Math.abs(b.index - this.targetIndex);
          });
        return records[0] || null;
      }

      startLoad(record, generation) {
        record.loading = true;
        record.image = new Image();
        this.activeLoads += 1;

        this.decodeImage(record.image, this.getFrameUrl(record.index)).then(() => {
          if (generation !== this.generation) {
            record.resolve(null);
            return;
          }
          record.decoded = true;
          record.loading = false;
          record.touched = ++this.touch;
          record.resolve(record);
          if (record.index === this.targetIndex) {
            this.drawRecord(record);
          } else if (this.isScrolling) {
            this.drawNearestFrame();
          }
        }).catch(() => {
          this.cache.delete(record.index);
          record.resolve(null);
        }).finally(() => {
          this.activeLoads = Math.max(0, this.activeLoads - 1);
          this.evictCache();
          this.pumpQueue(generation);
        });
      }

      decodeImage(image, src) {
        image.decoding = 'async';
        if (image.decode) {
          image.src = src;
          return image.decode();
        }
        return new Promise((resolve, reject) => {
          image.onload = resolve;
          image.onerror = reject;
          image.src = src;
        });
      }

      getFrameUrl(index) {
        const frameNumber = String(this.startIndex + index).padStart(this.padLength, '0');
        const file = `${this.config.prefix}${frameNumber}.${this.extension}`;
        return this.config.template.replace('__FRAME_FILE__', file).replace('__FRAME__', frameNumber);
      }

      isTargetDecoded() {
        const exact = this.cache.get(this.targetIndex);
        return !!(exact && exact.decoded);
      }

      drawTargetFrame() {
        const exact = this.cache.get(this.targetIndex);
        if (exact && exact.decoded) this.drawRecord(exact);
      }

      drawNearestFrame() {
        let nearest = null;
        this.cache.forEach((record) => {
          if (!record.decoded) return;
          if (!nearest || Math.abs(record.index - this.targetIndex) < Math.abs(nearest.index - this.targetIndex)) {
            nearest = record;
          }
        });
        if (nearest) this.drawRecord(nearest);
      }

      redrawCurrentFrame() {
        const current = this.cache.get(this.lastRenderedIndex);
        if (current && current.decoded) {
          this.drawRecord(current, true);
          return;
        }
        this.canvasReady = false;
        this.classList.remove('is-canvas-ready');
        this.drawTargetFrame();
      }

      drawRecord(record, force) {
        if (!record || !record.decoded) return;
        if (!force && this.lastRenderedIndex === record.index) return;
        this.resizeCanvas();
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.drawCover(record.image);
        record.touched = ++this.touch;
        this.lastRenderedIndex = record.index;
        if (!this.canvasReady) {
          this.canvasReady = true;
          this.classList.add('is-canvas-ready');
        }
      }

      drawCover(image) {
        const canvasRatio = this.canvas.width / this.canvas.height;
        const imageRatio = image.naturalWidth / image.naturalHeight;
        let drawWidth = this.canvas.width;
        let drawHeight = this.canvas.height;
        let drawX = 0;
        let drawY = 0;

        if (imageRatio > canvasRatio) {
          drawWidth = this.canvas.height * imageRatio;
          drawX = (this.canvas.width - drawWidth) / 2;
        } else {
          drawHeight = this.canvas.width / imageRatio;
          drawY = (this.canvas.height - drawHeight) / 2;
        }

        this.ctx.drawImage(image, drawX, drawY, drawWidth, drawHeight);
      }

      evictCache() {
        this.trimQueuedFrames();

        const protectedIndexes = new Set([this.targetIndex, this.lastRenderedIndex]);
        const records = Array.from(this.cache.values())
          .filter((record) => record.decoded && !protectedIndexes.has(record.index))
          .sort((a, b) => a.touched - b.touched);

        while (this.decodedCount() > this.config.cacheSize && records.length) {
          const record = records.shift();
          this.cache.delete(record.index);
        }
      }

      trimQueuedFrames() {
        const maxRecords = this.config.cacheSize + this.lookahead + this.trailingLookback + this.maxConcurrent + 4;
        const staleQueued = Array.from(this.cache.values()).filter((record) => {
          return !record.decoded && !record.loading && record.index !== this.targetIndex && !this.isInActiveWindow(record.index);
        });

        staleQueued.forEach((record) => {
          this.cache.delete(record.index);
          record.resolve(null);
        });

        if (this.cache.size <= maxRecords) return;

        const records = Array.from(this.cache.values())
          .filter((record) => !record.decoded && !record.loading && record.index !== this.targetIndex)
          .sort((a, b) => Math.abs(b.index - this.targetIndex) - Math.abs(a.index - this.targetIndex));

        while (this.cache.size > maxRecords && records.length) {
          const record = records.shift();
          this.cache.delete(record.index);
          record.resolve(null);
        }
      }

      isInActiveWindow(index) {
        if (this.reducedMotion.matches) return this.reducedMotionFrameIndexes.includes(index);
        const delta = (index - this.targetIndex) * this.direction;
        return delta >= -this.trailingLookback && delta <= this.lookahead;
      }

      dropIdleQueuedFrames() {
        this.cache.forEach((record, index) => {
          if (index === this.targetIndex || record.decoded || record.loading) return;
          this.cache.delete(index);
          record.resolve(null);
        });
      }

      decodedCount() {
        let count = 0;
        this.cache.forEach((record) => {
          if (record.decoded) count += 1;
        });
        return count;
      }

      clearCache() {
        this.cache.forEach((record) => {
          if (!record.decoded) record.resolve(null);
        });
        this.cache.clear();
      }

      clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }
    }

    customElements.define('ndev-asset-frame-sequence', NdevAssetFrameSequence);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-card-switcher"] && !Shopify.designMode) return;
  try {
    class NdevCardSwitcher extends BaseElement {
    createdCallback() {
      this._managedChildren = [];
      this._selectorInstances = [];
      this._activeIndex = 0;
    }

    init() {
      this._onSelect = (e) => {
        if (!this._selectorInstances.includes(e.target)) return;
        this.setActive(e.detail.index);
      };
      this.addEventListener('ndev:select', this._onSelect);

      this._buildSelector();
    }

    dispose() {
      if (this._onSelect) {
        this.removeEventListener('ndev:select', this._onSelect);
        delete this._onSelect;
      }
      const sel = this.querySelector('[data-selector-container]');
      if (sel) sel.innerHTML = '';
      this._managedChildren = [];
      this._selectorInstances = [];
    }

    _buildSelector() {
      const contentEl = this.querySelector('[data-switcher-content]');
      if (!contentEl) return;

      for (let k = 0; k < contentEl.children.length; k++) {
        contentEl.children[k].style.display = 'none';
      }

      const rawChildren = contentEl.querySelectorAll(':scope > [data-switcher-option-label]');
      if (rawChildren.length === 0) {
        for (let k = 0; k < contentEl.children.length; k++) {
          contentEl.children[k].style.display = '';
        }
        return;
      }

      const uniqueLabels = [];
      const labelIndexMap = {};
      const labelColors = [];

      for (let i = 0; i < rawChildren.length; i++) {
        const child = rawChildren[i];
        const label = (child.getAttribute('data-switcher-option-label') || '').trim();
        if (!label) continue;
        if (!(label in labelIndexMap)) {
          labelIndexMap[label] = uniqueLabels.length;
          uniqueLabels.push(label);
          labelColors.push(child.getAttribute('data-switcher-swatch-color') || '');
        }
        child._switcherOptionIndex = labelIndexMap[label];
        this._managedChildren.push(child);
      }

      if (uniqueLabels.length === 0) {
        for (let k = 0; k < contentEl.children.length; k++) {
          contentEl.children[k].style.display = '';
        }
        return;
      }

      const type = this.dataset.selectorType || 'button';
      const defaultActive = Math.max(0, parseInt(this.dataset.defaultActive, 10) || 0);
      this._activeIndex = defaultActive < uniqueLabels.length ? defaultActive : 0;

      const labelsJSON = JSON.stringify(uniqueLabels);
      const colorsJSON = JSON.stringify(labelColors);

      this._switchGroup(this._activeIndex);

      this._managedChildren.forEach((child) => {
        const area = child.querySelector('[data-switcher-area]');
        if (!area) return;
        const sel = document.createElement('ndev-card-selector');
        sel.dataset.labels = labelsJSON;
        sel.dataset.type = type;
        sel.dataset.colors = colorsJSON;
        sel.dataset.active = String(this._activeIndex);
        area.appendChild(sel);
        this._selectorInstances.push(sel);
      });
    }

    setActive(index) {
      if (index === this._activeIndex) return;
      this._activeIndex = index;
      this._switchGroup(index);
      for (let i = 0; i < this._selectorInstances.length; i++) {
        this._selectorInstances[i].setActive(index);
      }
    }

    _switchGroup(activeIndex) {
      for (let i = 0; i < this._managedChildren.length; i++) {
        const child = this._managedChildren[i];
        child.style.display = child._switcherOptionIndex === activeIndex ? '' : 'none';
      }
    }
  }

  if (!customElements.get('ndev-card-switcher')) {
    customElements.define('ndev-card-switcher', NdevCardSwitcher);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-cart-api"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.$narwalCart) return;

    /**
     * routesRoot:
     * - 统一获取 Shopify routes.root（兼容多语言子路径）
     */
    function routesRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    }

    /**
     * formatMoney:
     * - 优先使用 Shopify.formatMoney
     * - 兜底为简单的 cents/100 显示
     */
    function getMoneyFormat(moneyFormat) {
      // 注意：这里避免出现会被 Liquid/Linter 识别为模板语法的字符序列
      return moneyFormat || (window.Shopify && window.Shopify.money_format) || '$ {amount}';
    }

    function formatMoney(cents, moneyFormat) {
      try {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, getMoneyFormat(moneyFormat));
        }
      } catch (e) {}
      var n = (cents || 0) / 100;
      return (Math.round(n * 100) / 100).toFixed(2);
    }

    async function requestJson(path, options) {
      const res = await fetch(path, Object.assign({
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      }, options || {}));

      if (!res.ok) {
        let msg = 'Request failed';
        try {
          const data = await res.json();
          msg = (data && (data.description || data.message)) || msg;
        } catch (e) {}
        const err = new Error(msg);
        err.status = res.status;
        throw err;
      }

      return await res.json();
    }

    /**
     * 端点薄封装（底层通用能力）
     * - 不做业务语义，只负责对接 Shopify Ajax Cart API
     */
    async function cartGet() {
      return await requestJson(routesRoot() + 'cart.js', { method: 'GET' });
    }

    async function cartAdd(payload) {
      return await requestJson(routesRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(payload || {})
      });
    }

    async function cartChange(payload) {
      return await requestJson(routesRoot() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(payload || {})
      });
    }

    async function cartUpdate(payload) {
      return await requestJson(routesRoot() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(payload || {})
      });
    }

    /**
     * getCart:
     * - 返回整车 cart（/cart.js）
     */
    async function getCart() {
      return await cartGet();
    }

    /**
     * addItem:
     * - 注意返回值是 line item（非整车）
     */
    async function addItem(params) {
      const payload = {
        id: params.variantId,
        quantity: params.quantity || 1
      };
      if (params.properties) payload.properties = params.properties;
      if (params.sellingPlan) payload.selling_plan = params.sellingPlan;

      return await cartAdd(payload);
    }

    /**
     * addItems:
     * - 批量加购（同样返回 line item 结构 / 或 Shopify 返回的 add.js 响应）
     */
    async function addItems(params) {
      const items = (params && params.items) ? params.items : [];
      const payload = {
        items: items.map((it) => {
          const row = { id: it.variantId, quantity: it.quantity || 1 };
          if (it.properties) row.properties = it.properties;
          if (it.sellingPlan) row.selling_plan = it.sellingPlan;
          return row;
        })
      };

      return await cartAdd(payload);
    }

    /**
     * setLineQuantity:
     * - Shopify /cart/change.js 返回整车 cart
     */
    async function setLineQuantity(params) {
      return await cartChange({ line: params.line, quantity: params.quantity });
    }

    /**
     * setLineQuantityByKey:
     * - Shopify /cart/change.js 支持用 line item key（id=key）更新数量
     */
    async function setLineQuantityByKey(params) {
      return await cartChange({ id: params.key, quantity: params.quantity });
    }

    /**
     * incrementLineQuantity / decrementLineQuantity:
     * - 基于 setLineQuantity 的语义封装
     * - 若未提供 currentQuantity，会先拉取 cart 计算当前 quantity
     */
    async function getLineQuantityFromCart(line) {
      const cart = await getCart();
      const idx = Math.max(0, (parseInt(line, 10) || 1) - 1);
      const item = (cart && Array.isArray(cart.items)) ? cart.items[idx] : null;
      const q = item ? (parseInt(item.quantity, 10) || 0) : 0;
      return { cart, quantity: q };
    }

    async function incrementLineQuantity(params) {
      const line = params && typeof params.line !== 'undefined' ? params.line : 0;
      const delta = Math.max(0, parseInt((params && params.delta) ? params.delta : 1, 10) || 1);
      let currentQuantity = (params && typeof params.currentQuantity !== 'undefined') ? parseInt(params.currentQuantity, 10) : NaN;

      if (isNaN(currentQuantity)) {
        const res = await getLineQuantityFromCart(line);
        currentQuantity = res.quantity;
      }
      const next = Math.max(0, currentQuantity + delta);
      return await setLineQuantity({ line: line, quantity: next });
    }

    async function decrementLineQuantity(params) {
      const line = params && typeof params.line !== 'undefined' ? params.line : 0;
      const delta = Math.max(0, parseInt((params && params.delta) ? params.delta : 1, 10) || 1);
      let currentQuantity = (params && typeof params.currentQuantity !== 'undefined') ? parseInt(params.currentQuantity, 10) : NaN;

      if (isNaN(currentQuantity)) {
        const res = await getLineQuantityFromCart(line);
        currentQuantity = res.quantity;
      }
      const next = Math.max(0, currentQuantity - delta);
      return await setLineQuantity({ line: line, quantity: next });
    }

    /**
     * discount codes（语义层）：
     * - setDiscountCodes: string | string[]
     * - clearDiscountCodes: 清空所有 discounts
     */
    function normalizeDiscountCodes(input) {
      if (Array.isArray(input)) {
        const map = {};
        const out = [];
        input.forEach(function (x) {
          const s = (x == null) ? '' : String(x);
          const t = s.trim();
          if (!t) return;
          const k = t.toLowerCase();
          if (map[k]) return;
          map[k] = true;
          out.push(t);
        });
        return out.join(',');
      }
      if (input == null) return '';
      // 允许直接传 'A,B'，同时做 trim
      return String(input).split(',').map(function (s) { return (s || '').trim(); }).filter(Boolean).join(',');
    }

    async function setDiscountCodes(codes) {
      const discount = normalizeDiscountCodes(codes);
      return await cartUpdate({ discount: discount });
    }

    async function clearDiscountCodes() {
      return await cartUpdate({ discount: '' });
    }

    /**
     * getTotals:
     * - 统一计算总价/原价/优惠等（容错空 cart）
     */
    function getTotals(cart) {
      const total_price = (cart && cart.total_price) || 0;
      const original_total_price = (cart && cart.original_total_price) || total_price;
      const total_discount = (cart && cart.total_discount) || 0;
      const total_savings = Math.max(0, original_total_price - total_price);
      return { total_price, original_total_price, total_discount, total_savings };
    }

    /**
     * countItems:
     * - 默认用 cart.item_count
     * - 可选排除某些 properties 前缀（用于不计入某类赠品/隐藏项等场景）
     */
    function countItems(cart, options) {
      const opts = options || {};
      const excludePrefixes = Array.isArray(opts.excludePropertyPrefixes) ? opts.excludePropertyPrefixes : [];
      if (!excludePrefixes.length) return (cart && cart.item_count) || 0;

      let count = 0;
      const items = (cart && cart.items) ? cart.items : [];
      for (var i = 0; i < items.length; i++) {
        const it = items[i];
        const props = it && it.properties ? it.properties : null;
        let excluded = false;
        if (props) {
          for (var p = 0; p < excludePrefixes.length; p++) {
            const prefix = excludePrefixes[p];
            for (var k in props) {
              if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
              if (String(k).indexOf(prefix) === 0) {
                excluded = true;
                break;
              }
            }
            if (excluded) break;
          }
        }
        if (!excluded) count += (it.quantity || 0);
      }
      return count;
    }

    /**
     * updateHeaderCartCount:
     * - 仅更新 header DOM，不请求接口
     * - selector 支持定制（默认 `.header-cart-number .cart-count`）
     */
    function updateHeaderCartCount(count, options) {
      const opts = options || {};
      const countEl = document.querySelector(opts.countSelector || '.header-cart-number .cart-count');
      const wrapperEl = document.querySelector(opts.wrapperSelector || '.header-cart-number');
      const n = Math.max(0, parseInt(count, 10) || 0);

      if (countEl) countEl.textContent = String(n);
      if (wrapperEl) {
        if (n > 0) {
          wrapperEl.classList.remove('hide-m');
          wrapperEl.classList.add('flex');
        } else {
          wrapperEl.classList.add('hide-m');
          wrapperEl.classList.remove('flex');
        }
      }
    }

    /**
     * syncHeaderCartCount:
     * - 拉取最新 cart，然后更新 header 数量
     * - 返回最新 count；失败返回 -1（不抛错，避免影响主流程）
     *
     * 为什么需要它：
     * - add.js 返回 line item，无法可靠得到最新 item_count
     * - 各模块（推荐区/mini cart/弹层）都可能需要“加购后同步 header”
     */
    async function syncHeaderCartCount(options) {
      try {
        const cart = await getCart();
        const count = countItems ? countItems(cart) : ((cart && cart.item_count) || 0);
        updateHeaderCartCount(count, options || {});
        return count;
      } catch (e) {
        return -1;
      }
    }

    window.$narwalCart = {
      routesRoot,
      formatMoney,
      requestJson,
      cartGet,
      cartAdd,
      cartChange,
      cartUpdate,
      getCart,
      addItem,
      addItems,
      setLineQuantity,
      setLineQuantityByKey,
      incrementLineQuantity,
      decrementLineQuantity,
      setDiscountCodes,
      clearDiscountCodes,
      getTotals,
      countItems,
      updateHeaderCartCount,
      syncHeaderCartCount
    };

    try {
      if ($narwal?.emit && typeof $narwal.emit === 'function') {
        $narwal.emit('cart:init', window.$narwalCart);
      }
    } catch (e) {}
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-checkbox"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.ndevCheckboxInitialized) return;
    window.ndevCheckboxInitialized = true;

    document.addEventListener('change', function(event) {
      const checkbox = event.target;
      if (!checkbox || !checkbox.matches('.ndev-checkbox-input')) return;

      const detail = {
        id: checkbox.id,
        name: checkbox.name,
        value: checkbox.value,
        checked: checkbox.checked,
        element: checkbox
      };

      checkbox.dispatchEvent(new CustomEvent('checkbox:change', {
        bubbles: true,
        composed: true,
        detail: detail
      }));

      if (window.$narwal && typeof window.$narwal.emit === 'function') {
        window.$narwal.emit('checkbox:change', detail);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-countup"] && !Shopify.designMode) return;
  try {
    (function() {
  // 使用 WeakMap 跟踪每个容器的 observer 和动画状态，支持清理
  const elementState = new WeakMap();

  const parseNumberFromText = (text) => {
    const match = text.match(/[-+]?[0-9]*\.?[0-9]+/);
    return match ? parseFloat(match[0]) : null;
  };

  const formatNumber = (num, thousandsSeparator) => {
    const fixed = num.toFixed(0);
    const parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
    return parts.join('.');
  };

  const easeOutQuart = t => 1 - (--t) * t * t * t;

  /**
   * 数字增长动画函数
   * @param {HTMLElement} el - 显示数字的元素
   * @param {number} start - 起始数字
   * @param {number} end - 结束数字
   * @param {number} duration - 动画时长（秒）
   * @param {string} thousandsSeparator - 千分位分隔符
   * @param {Function} onComplete - 动画完成回调
   */
  const animateCountUp = (el, start, end, duration, thousandsSeparator, onComplete) => {
    const startTime = performance.now();

    const update = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / (duration * 1000), 1);
      const easedProgress = easeOutQuart(progress);

      const current = start + (end - start) * easedProgress;
      el.textContent = formatNumber(current, thousandsSeparator);

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        el.textContent = formatNumber(end, thousandsSeparator);
        if (onComplete) onComplete();
      }
    };

    requestAnimationFrame(update);
  };

  const processElement = (container) => {
    const text = container.textContent.trim();
    const number = parseNumberFromText(text);

    if (number === null) return;

    const duration = parseFloat(container.dataset.duration) || 2.5;
    const prefix = container.dataset.prefix || '';
    const suffix = container.dataset.suffix || '';
    const thousandsSeparator = container.dataset.thousandsSeparator || ' ';

    // 预计算最终格式化的数字字符串
    const finalNumberText = formatNumber(number, thousandsSeparator);

    // 创建前缀 span
    const prefixSpan = document.createElement('span');
    prefixSpan.className = 'countup-prefix';
    prefixSpan.textContent = prefix;

    // 创建数字 span - 先设置为最终值以计算宽度
    const numberSpan = document.createElement('span');
    numberSpan.className = 'countup-number';
    numberSpan.textContent = finalNumberText;

    // 创建后缀 span
    const suffixSpan = document.createElement('span');
    suffixSpan.className = 'countup-suffix';
    suffixSpan.textContent = suffix;

    const textWithoutNumber = text.replace(/[-+]?[0-9]*\.?[0-9]+/, '');
    container.textContent = textWithoutNumber;
    container.appendChild(prefixSpan);
    container.appendChild(numberSpan);
    container.appendChild(suffixSpan);

    // 获取最终宽度并设置，避免动画过程中宽度变化
    const finalWidth = numberSpan.offsetWidth;
    numberSpan.style.width = finalWidth + 'px';

    // 重置为起始值，准备动画
    numberSpan.textContent = formatNumber(0, thousandsSeparator);

    // 标记动画是否正在播放
    let isAnimating = false;
    let hasAnimated = false;

    // 使用 Intersection Observer + checkVisibility 检测元素可见性
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const isVisible = entry.isIntersecting && container.checkVisibility();

        if (isVisible && !hasAnimated) {
          // 第一次进入视口且可见 - 播放动画
          hasAnimated = true;
          isAnimating = true;
          animateCountUp(numberSpan, 0, number, duration, thousandsSeparator, () => {
            isAnimating = false;
          });
        } else if (!isVisible && isAnimating) {
          // 动画播放中但元素变为不可见 - 重置状态，允许下次重新播放
          hasAnimated = false;
          isAnimating = false;
          numberSpan.textContent = formatNumber(0, thousandsSeparator);
        } else if (isVisible && hasAnimated && !isAnimating) {
          // 已经播放过但元素重新变为可见 - 重新播放
          isAnimating = true;
          animateCountUp(numberSpan, 0, number, duration, thousandsSeparator, () => {
            isAnimating = false;
          });
        } else if (!isVisible && hasAnimated) {
          // 不可见时重置数字为 0
          numberSpan.textContent = formatNumber(0, thousandsSeparator);
        }
      });
    }, observerOptions);

    observer.observe(container);

    // 保存 observer 和状态以便清理
    elementState.set(container, { observer, numberSpan });
  };

  function initCountups(scope) {
    const base = scope && scope.querySelectorAll ? scope : document;
    base.querySelectorAll('.ndev-countup').forEach(processElement);
  }

  function destroyCountups(scope) {
    const base = scope && scope.querySelectorAll ? scope : document;
    base.querySelectorAll('.ndev-countup').forEach((el) => {
      const state = elementState.get(el);
      if (state) {
        state.observer.disconnect();
        elementState.delete(el);
      }
    });
  }

  // 页面加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initCountups();
    });
  } else {
    initCountups();
  }

  // Shopify Section 加载后重新初始化
  document.addEventListener('shopify:section:load', function(event) {
    initCountups(event && event.target ? event.target : null);
  });

  // Shopify Section 卸载时清理 observer，防止内存泄漏
  document.addEventListener('shopify:section:unload', function(event) {
    destroyCountups(event && event.target ? event.target : null);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
    const GUARD = '__NDEV_DIALOG__';
    const DIALOG_SELECTOR = '[data-dialog]';
    const POSITION_ATTR = 'data-dialog-position';
    const POSITION_ATTR_MB = 'data-dialog-position-mb';

    if (window[GUARD]) return;

    const isClosingMap = new WeakMap();

    function getMatchMedia() {
      return window.matchMedia('(max-width: 1023px)');
    }

    function updatePosition(dialog) {
      const positionPc = dialog.getAttribute(POSITION_ATTR) || 'center';
      const positionMb = dialog.getAttribute(POSITION_ATTR_MB) || positionPc;
      const isMobile = getMatchMedia().matches;
      dialog.setAttribute(POSITION_ATTR, isMobile ? positionMb : positionPc);
    }

    function closeWithAnimation(dialog) {
      if (isClosingMap.get(dialog) || !dialog.open) return;
      isClosingMap.set(dialog, true);
      dialog.classList.add('closing');
      dialog.addEventListener('animationend', function handler(e) {
        if (e.target !== dialog) return;
        dialog.removeEventListener('animationend', handler);
        dialog.classList.remove('closing');
        isClosingMap.set(dialog, false);
        dialog.close();
      });
    }

    function openDialog(dialog) {
      if (!dialog) return;
      updatePosition(dialog);
      dialog.showModal();
    }

    function closeDialog(dialog) {
      if (!dialog || !dialog.open) return;
      closeWithAnimation(dialog);
    }

    function handleClick(dialog, e) {
      const rect = dialog.getBoundingClientRect();
      if (e.clientY < rect.top || e.clientY > rect.bottom ||
          e.clientX < rect.left || e.clientX > rect.right) {
        closeWithAnimation(dialog);
      }
    }

    function initDialog(dialog) {
      if (!dialog) return;

      updatePosition(dialog);

      const mm = getMatchMedia();
      const onMmChange = () => updatePosition(dialog);
      mm.addEventListener('change', onMmChange);

      const onDialogClick = (e) => handleClick(dialog, e);
      const onHide = (e) => { e.preventDefault(); closeWithAnimation(dialog); };
      const onCancel = (e) => { e.preventDefault(); closeWithAnimation(dialog); };

      dialog.addEventListener('click', onDialogClick);
      dialog.addEventListener('hide', onHide);
      dialog.addEventListener('cancel', onCancel);

      dialog.__dialogCleanup = () => {
        mm.removeEventListener('change', onMmChange);
        dialog.removeEventListener('click', onDialogClick);
        dialog.removeEventListener('hide', onHide);
        dialog.removeEventListener('cancel', onCancel);
        delete dialog.__dialogCleanup;
      };
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      base.querySelectorAll(DIALOG_SELECTOR).forEach(initDialog);
    }

    // 全局 API
    window[GUARD] = {
      open: openDialog,
      close: closeDialog,
      initAll: initAll,
    };

    // 事件委托：点击 [data-dialog-trigger] 时打开对应弹窗
    function handleTriggerClick(e) {
      const trigger = e.target.closest('[data-dialog-trigger]');
      if (!trigger) return;
      const targetId = trigger.getAttribute('data-dialog-trigger');
      const dialog = document.getElementById(targetId);
      if (!dialog) return;
      e.preventDefault();
      e.stopPropagation();
      openDialog(dialog);
    }

    document.addEventListener('click', handleTriggerClick);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const base = (event && event.target && event.target.querySelectorAll) ? event.target : null;
      if (!base) return;
      base.querySelectorAll(DIALOG_SELECTOR).forEach(dialog => {
        if (typeof dialog.__dialogCleanup === 'function') {
          dialog.__dialogCleanup();
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-fade-in-out-scroll"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_SELECTOR = '[data-ndev-fade-in-out-scroll]';
    const GUARD = '__ndevFadeInOutScroll';

    if (!window[GUARD]) {
      window[GUARD] = {};
    }

    function initAll(container) {
      if (typeof window.$narwal === 'undefined' || typeof window.$narwal.fadeInOut !== 'function') {
        return;
      }
      const base = container && container.querySelectorAll ? container : document;
      if (!base.querySelector(ROOT_SELECTOR)) {
        return;
      }
      window.$narwal.fadeInOut(ROOT_SELECTOR);
    }

    if (!window[GUARD].listenersBound) {
      window[GUARD].listenersBound = true;
      document.addEventListener('DOMContentLoaded', () => initAll());
      document.addEventListener('shopify:section:load', (event) => {
        initAll(event && event.target ? event.target : null);
      });
    }

    if (document.readyState !== 'loading') {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-fade-up-in-view"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_ATTR = 'data-ndev-fuiv';
    const INITIAL_VISIBLE_ATTR = 'data-ndev-fuiv-init';
    const ROOT_SELECTOR = `[${ROOT_ATTR}]`;
    const READY_CLASS = 'ndev-fade-up-in-view--ready';
    const VISIBLE_CLASS = 'ndev-fade-up-in-view--visible';
    const GUARD = '__ndevFadeUpInView';

    if (!window[GUARD]) {
      window[GUARD] = { instances: new WeakMap() };
    }
    const { instances } = window[GUARD];

    function show(root, repeat) {
      root.classList.add(VISIBLE_CLASS);

      if (repeat) return;

      const observer = instances.get(root);
      if (!observer) return;
      observer.unobserve(root);
      instances.delete(root);
    }

    function isInViewport(root) {
      const rect = root.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

      return rect.bottom > 0 && rect.right > 0 && rect.top < viewportHeight && rect.left < viewportWidth;
    }

    function initOne(root) {
      if (!root || root.classList.contains(READY_CLASS)) return;

      const reducedMotion = Boolean(
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
      const repeat = root.getAttribute(ROOT_ATTR) === 'r';
      const initialVisible = root.hasAttribute(INITIAL_VISIBLE_ATTR) && isInViewport(root);

      root.classList.add(READY_CLASS);
      if (initialVisible) root.classList.add(VISIBLE_CLASS);

      if (reducedMotion || !('IntersectionObserver' in window)) {
        show(root, false);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              show(entry.target, repeat);
            } else if (repeat) {
              entry.target.classList.remove(VISIBLE_CLASS);
            }
          });
        },
        { threshold: 0 }
      );

      instances.set(root, observer);
      observer.observe(root);
    }

    function destroyOne(root) {
      const observer = instances.get(root);
      if (observer) {
        observer.unobserve(root);
        instances.delete(root);
      }

      root.classList.remove(READY_CLASS, VISIBLE_CLASS);
    }

    function forEachRoot(container, callback) {
      const scope = container || document;
      if (scope instanceof Element && scope.matches(ROOT_SELECTOR)) callback(scope);
      scope.querySelectorAll(ROOT_SELECTOR).forEach(callback);
    }

    function initAll(container) {
      forEachRoot(container, initOne);
    }

    if (!window[GUARD].listenersBound) {
      window[GUARD].listenersBound = true;
      document.addEventListener('DOMContentLoaded', () => initAll());
      document.addEventListener('shopify:section:load', (event) => initAll(event.target));
      document.addEventListener('shopify:section:unload', (event) => {
        forEachRoot(event.target, destroyOne);
      });
    }

    if (document.readyState !== 'loading') {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-feature-tabs-controller"] && !Shopify.designMode) return;
  try {
    if (!window.__ndevFeatureTabsControllerLoaded) {
    window.__ndevFeatureTabsControllerLoaded = true;

    class NdevFeatureTabsController extends BaseElement {
    init() {
      this.dispose();

      this.slides = Array.from(this.querySelectorAll('[data-ndev-feature-tabs-slide]'));
      this.navs = Array.from(this.querySelectorAll('[data-ndev-feature-tabs-nav]'));
      this.track = this.querySelector('[data-ndev-feature-tabs-track], .r32-feature-tabs__track, .j68-feature-tabs__track, .v50-comparison-carousel__track');
      this.currentEl = this.querySelector('[data-ndev-feature-tabs-mobile-current]');
      this.prevButton = this.querySelector('[data-ndev-feature-tabs-mobile-prev]');
      this.nextButton = this.querySelector('[data-ndev-feature-tabs-mobile-next]');
      this.mobileStyle = this.getAttribute('mobile-style') || 'tabs';
      this.engine = this.getAttribute('engine') || 'feature-tabs';
      this.autoplay = this.getAttribute('autoplay') === 'true';
      this.delay = Math.max(1200, Number(this.getAttribute('autoplay-delay')) || 5000);
      this.playbackTrigger = this.getAttribute('playback-trigger') || 'in_view';
      if (this.playbackTrigger === 'immediate') this.playbackTrigger = 'always';
      this.desktopMq = window.matchMedia('(min-width: 1024px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.defaultIndex = this.findDefaultIndex();
      this.activeIndex = this.defaultIndex;
      this.isInView = this.playbackTrigger !== 'in_view';
      this.raf = 0;
      this.startTime = 0;
      this.observer = null;
      this.activeTimelineFill = null;
      this.activeProgressRing = null;
      this.mobileProgressRing = this.querySelector('[data-ndev-feature-tabs-progress-ring="mobile"]');

      this.onNavClick = this.onNavClick.bind(this);
      this.onPrevClick = this.onPrevClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onIntersection = this.onIntersection.bind(this);
      this.onBreakpointChange = this.onBreakpointChange.bind(this);
      this.onMotionChange = this.onMotionChange.bind(this);
      this.onResize = this.onResize.bind(this);
      this.tick = this.tick.bind(this);

      this.navs.forEach((nav) => nav.addEventListener('click', this.onNavClick));
      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);
      this.desktopMq.addEventListener('change', this.onBreakpointChange);
      this.reducedMotion.addEventListener('change', this.onMotionChange);
      window.addEventListener('resize', this.onResize);

      this.activate(this.activeIndex, { resetProgress: true, restartAutoplay: false });
      this.setupPlayback();
      this.classList.add('is-ready');
    }

    dispose() {
      if (this.navs) this.navs.forEach((nav) => nav.removeEventListener('click', this.onNavClick));
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
      if (this.desktopMq) this.desktopMq.removeEventListener('change', this.onBreakpointChange);
      if (this.reducedMotion) this.reducedMotion.removeEventListener('change', this.onMotionChange);
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      this.destroyObserver();
      this.stopAutoplay();
      this.classList.remove('is-ready');
    }

    findDefaultIndex() {
      const defaultIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      return defaultIndex >= 0 ? defaultIndex : 0;
    }

    onNavClick(event) {
      const selection = window.getSelection();
      const selectedInsideNav =
        selection &&
        !selection.isCollapsed &&
        (event.currentTarget.contains(selection.anchorNode) || event.currentTarget.contains(selection.focusNode));
      if (event.detail > 0 && selectedInsideNav) return;

      const slide = event.currentTarget.closest('[data-ndev-feature-tabs-slide]');
      const index = this.slides.indexOf(slide);
      if (index >= 0) this.activate(index, { resetProgress: true });
    }

    onPrevClick() {
      if (!this.slides.length) return;
      this.activate((this.activeIndex - 1 + this.slides.length) % this.slides.length, { resetProgress: true });
    }

    onNextClick() {
      if (!this.slides.length) return;
      this.activate((this.activeIndex + 1) % this.slides.length, { resetProgress: true });
    }

    onIntersection(entries) {
      const inView = Boolean(entries[0] && entries[0].isIntersecting);
      if (inView === this.isInView) return;
      this.isInView = inView;
      if (inView) {
        this.resetProgress();
        this.startAutoplay();
      } else {
        this.resetToDefault();
      }
    }

    onBreakpointChange() {
      this.syncVisibility();
      this.applyTrackTransform();
      if (this.desktopMq.matches || this.engine !== 'desktop-accordion') this.startAutoplay();
      else this.stopAutoplay();
    }

    onMotionChange() {
      if (this.reducedMotion.matches) this.stopAutoplay();
      else this.startAutoplay();
    }

    onResize() {
      this.applyTrackTransform();
    }

    setupPlayback() {
      if (!this.autoplay) return;
      if (this.playbackTrigger !== 'in_view' || !('IntersectionObserver' in window)) {
        this.isInView = true;
        this.startAutoplay();
        return;
      }

      this.observer = new IntersectionObserver(this.onIntersection, { threshold: 0.35 });
      this.observer.observe(this);
    }

    destroyObserver() {
      if (!this.observer) return;
      this.observer.disconnect();
      this.observer = null;
    }

    shouldHideInactiveRegions() {
      if (this.engine === 'desktop-accordion') return this.desktopMq.matches;
      if (this.desktopMq.matches) return true;
      return this.mobileStyle !== 'carousel';
    }

    syncVisibility() {
      const hideInactive = this.shouldHideInactiveRegions();
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.activeIndex;
        slide.querySelectorAll('[data-ndev-feature-tabs-panel], .ndev-feature-tabs-slide__panel, [data-ndev-feature-tabs-mobile-content], .ndev-feature-tabs-slide__mobile-content').forEach((region) => {
          const hide = hideInactive && !active;
          region.toggleAttribute('hidden', hide);
          region.toggleAttribute('inert', hide);
          region.setAttribute('aria-hidden', hide ? 'true' : 'false');
        });
      });
    }

    activate(index, options) {
      if (!this.slides.length) return;
      const config = options || {};
      this.activeIndex = Math.min(Math.max(index, 0), this.slides.length - 1);

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.activeIndex;
        slide.classList.toggle('is-active', active);
        slide.querySelectorAll('[data-ndev-feature-tabs-nav]').forEach((nav) => {
          nav.setAttribute('aria-expanded', active ? 'true' : 'false');
        });
        this.resetSlideProgress(slide);
      });

      this.syncVisibility();
      this.updateCounter();
      this.updateProgressTargets();
      this.applyTrackTransform();

      if (config.resetProgress !== false) {
        this.resetProgress();
        if (config.restartAutoplay !== false) this.startAutoplay();
      }
    }

    updateCounter() {
      if (this.currentEl) this.currentEl.textContent = String(this.activeIndex + 1).padStart(2, '0');
    }

    updateProgressTargets() {
      const activeSlide = this.slides[this.activeIndex];
      this.activeTimelineFill = activeSlide ? activeSlide.querySelector('.ndev-feature-tabs-timeline__fill') : null;
      this.activeProgressRing = activeSlide
        ? activeSlide.querySelector('[data-ndev-feature-tabs-progress-ring="desktop"]')
        : null;
    }

    resetSlideProgress(slide) {
      const fill = slide.querySelector('.ndev-feature-tabs-timeline__fill');
      const ring = slide.querySelector('[data-ndev-feature-tabs-progress-ring="desktop"]');
      if (fill) fill.style.transform = 'translateX(-50%) scaleY(0)';
      if (ring) ring.style.strokeDashoffset = '1';
    }

    applyTrackTransform() {
      if (!this.track || this.mobileStyle !== 'carousel') return;
      if (this.desktopMq.matches) {
        this.track.style.transform = '';
        return;
      }

      const firstSlide = this.slides[0];
      const firstCard = firstSlide
        ? firstSlide.querySelector('[data-ndev-feature-tabs-panel], .ndev-feature-tabs-slide__panel')
        : null;
      if (!firstCard) return;

      const cardWidth = firstCard.getBoundingClientRect().width;
      const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
      const offset = this.activeIndex * (cardWidth + gap);
      this.track.style.transform = offset > 0 ? `translateX(-${offset}px)` : '';
    }

    resetToDefault() {
      this.stopAutoplay();
      this.activate(this.defaultIndex, { resetProgress: true, restartAutoplay: false });
    }

    resetProgress() {
      this.startTime = performance.now();
      this.writeProgress(0);
    }

    startAutoplay() {
      this.stopAutoplay();
      if (!this.canPlay()) return;
      this.raf = requestAnimationFrame(this.tick);
    }

    canPlay() {
      if (!this.autoplay || this.reducedMotion.matches || this.slides.length <= 1) return false;
      if (this.engine === 'desktop-accordion' && !this.desktopMq.matches) return false;
      return this.playbackTrigger !== 'in_view' || this.isInView;
    }

    stopAutoplay() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
    }

    tick(now) {
      if (!this.canPlay()) {
        this.stopAutoplay();
        return;
      }
      if (!this.startTime) this.startTime = now;
      const progress = Math.min((now - this.startTime) / this.delay, 1);
      this.writeProgress(progress);
      if (progress >= 1) {
        this.activate((this.activeIndex + 1) % this.slides.length, { resetProgress: true });
        return;
      }
      this.raf = requestAnimationFrame(this.tick);
    }

    writeProgress(progress) {
      const safeProgress = Math.min(Math.max(progress, 0), 1);
      const dashOffset = String(1 - safeProgress);
      if (this.activeTimelineFill) {
        this.activeTimelineFill.style.transform = `translateX(-50%) scaleY(${safeProgress.toFixed(4)})`;
      }
      if (this.activeProgressRing) this.activeProgressRing.style.strokeDashoffset = dashOffset;
      if (this.mobileProgressRing) this.mobileProgressRing.style.strokeDashoffset = dashOffset;
    }
    }

    const featureTabsTags = [
      'ndev-feature-tabs',
      'ndev-r32-feature-tabs',
      'ndev-j68-feature-tabs',
      'ndev-v50-vacuum-comparison-carousel',
      'ndev-v50-triple-anti-tangle'
    ];

    featureTabsTags.forEach((tagName) => {
      if (!customElements.get(tagName)) {
        customElements.define(tagName, class extends NdevFeatureTabsController {});
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-home-kol-carousel"] && !Shopify.designMode) return;
  try {
    class NdevHomeKolCarousel extends BaseElement {
    init() {
      const initialRealIndex = Number.isInteger(this.pendingRealIndex) ? this.pendingRealIndex : 0;
      this.dispose();

      this.pendingRealIndex = null;
      this.listeners = [];
      this.updateFrame = 0;
      this.reinitializeFrame = 0;
      this.swiperElement = this.querySelector('.ndev-home-kol-carousel__swiper');
      this.wrapper = this.querySelector('.ndev-home-kol-carousel__wrapper');
      this.panel = this.closest('.ndev-home-kol-tab__panel');
      this.slides = this.wrapper ? Array.from(this.wrapper.querySelectorAll(':scope > .ndev-home-kol-carousel__slide')) : [];
      this.platformSingleClass = `ndev-home-kol-${this.getAttribute('platform')}-carousel--single`;

      if (!this.swiperElement || !this.wrapper || !this.slides.length) return;

      const isSingle = this.slides.length <= 1;
      this.classList.toggle('ndev-home-kol-carousel--single', isSingle);
      this.classList.toggle(this.platformSingleClass, isSingle);
      if (typeof window.Swiper === 'undefined') return;

      this.slides.forEach((slide) => {
        const video = slide.querySelector('video');
        if (video) {
          video.controls = false;
          video.preload = 'none';
        }
      });

      this.setAttribute('enhanced', '');
      this.listen(this, 'click', (event) => this.handleClick(event));
      this.listen(this, 'play', (event) => this.handleVideoState(event), true);
      this.listen(this, 'pause', (event) => this.handleVideoState(event), true);
      this.listen(this, 'ended', (event) => this.handleVideoState(event), true);
      this.listen(this, 'timeupdate', (event) => this.handleVideoState(event), true);
      this.listen(this, 'durationchange', (event) => this.handleVideoState(event), true);
      this.listen(this, 'volumechange', (event) => this.handleVideoState(event), true);
      this.listen(this, 'input', (event) => this.handleProgressInput(event));
      this.listen(document, 'visibilitychange', () => {
        if (document.hidden) this.pauseAllVideos();
      });
      this.listen(document, 'shopify:block:select', (event) => this.handleBlockSelect(event));
      if (this._mq?.addEventListener) {
        this.listen(this._mq, 'change', () => this.reinitializeForViewport());
      }

      if (this.panel && typeof MutationObserver !== 'undefined') {
        this.panelObserver = new MutationObserver(() => {
          if (this.panel.hidden || this.panel.hasAttribute('inert')) this.pauseAllVideos();
          else this.swiper?.update?.();
        });
        this.panelObserver.observe(this.panel, { attributes: true, attributeFilter: ['hidden', 'inert'] });
      }

      if (typeof IntersectionObserver !== 'undefined') {
        this.visibilityObserver = new IntersectionObserver((entries) => {
          if (!entries[0]?.isIntersecting) this.pauseAllVideos();
        }, { threshold: 0.05 });
        this.visibilityObserver.observe(this);
      }

      const mobileSlidesPerView = Number.parseFloat(this.getAttribute('mobile-slides-per-view'));
      const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;
      this.swiper = new window.Swiper(this.swiperElement, {
        initialSlide: initialRealIndex,
        slidesPerView: Number.isFinite(mobileSlidesPerView) && mobileSlidesPerView > 0 ? mobileSlidesPerView : 1,
        centeredSlides: true,
        spaceBetween: 16,
        speed: reducedMotion ? 0 : 500,
        loop: this.slides.length > 1,
        loopAdditionalSlides: 1,
        noSwiping: true,
        noSwipingSelector: '.ndev-home-kol-card__progress',
        watchSlidesProgress: true,
        slideToClickedSlide: false,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        navigation: {
          prevEl: this.querySelector('.ndev-home-kol-carousel__nav--prev'),
          nextEl: this.querySelector('.ndev-home-kol-carousel__nav--next'),
        },
        breakpoints: {
          1024: {
            slidesPerView: 'auto',
            centeredSlides: false,
            spaceBetween: 20,
          },
        },
        on: {
          init: (swiper) => {
            this.syncActiveState(swiper.slides[swiper.activeIndex], swiper.slides);
          },
          beforeTransitionStart: () => this.pauseAllVideos(),
          activeIndexChange: (swiper) => this.syncActiveState(swiper.slides[swiper.activeIndex], swiper.slides),
          transitionEnd: (swiper) => this.syncActiveState(swiper.slides[swiper.activeIndex], swiper.slides),
          resize: () => this.scheduleSwiperUpdate(),
        },
      });
    }

    listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      this.listeners.push({ target, type, handler, options });
    }

    reinitializeForViewport() {
      if (!this.swiper || this.swiper.destroyed) return;
      const activeSlide = this.swiper.slides[this.swiper.activeIndex];
      const slideRealIndex = Number(activeSlide?.getAttribute('data-swiper-slide-index'));
      const realIndex = Number.isFinite(slideRealIndex) ? slideRealIndex : this.swiper.realIndex;
      this.pauseAllVideos();
      window.cancelAnimationFrame(this.reinitializeFrame);
      this.reinitializeFrame = window.requestAnimationFrame(() => {
        this.pendingRealIndex = Number.isInteger(realIndex) ? realIndex : 0;
        this.init();
      });
    }

    scheduleSwiperUpdate() {
      if (!this.swiper || this.swiper.destroyed) return;
      window.cancelAnimationFrame(this.updateFrame);
      this.updateFrame = window.requestAnimationFrame(() => {
        if (!this.swiper || this.swiper.destroyed) return;
        this.swiper.updateSlides();
        this.swiper.updateProgress();
        this.swiper.updateSlidesClasses();
        this.syncActiveState(this.swiper.slides[this.swiper.activeIndex], this.swiper.slides);
      });
    }

    syncActiveState(activeSlide, runtimeSlides) {
      if (!activeSlide) return;
      const slides = runtimeSlides
        ? Array.from(runtimeSlides)
        : Array.from(this.querySelectorAll('.ndev-home-kol-carousel__slide'));

      slides.forEach((slide) => {
        const isActive = slide === activeSlide;
        const isVisible = isActive || slide.classList.contains('swiper-slide-visible');
        const selectButton = slide.querySelector('.ndev-home-kol-card__select');
        const fallbackLink = slide.querySelector('.ndev-home-kol-card__fallback-link');
        const progress = slide.querySelector('.ndev-home-kol-card__progress');
        const playButton = slide.querySelector('.ndev-home-kol-card__control--play');
        const muteButton = slide.querySelector('.ndev-home-kol-card__control--mute');

        if (isActive) slide.setAttribute('aria-current', 'true');
        else slide.removeAttribute('aria-current');
        slide.toggleAttribute('inert', !isVisible);
        if (selectButton) {
          selectButton.hidden = isActive;
          selectButton.tabIndex = !isActive && isVisible ? 0 : -1;
        }
        if (fallbackLink) fallbackLink.tabIndex = isActive ? 0 : -1;
        if (progress) progress.tabIndex = isActive ? 0 : -1;
        if (playButton) playButton.tabIndex = isActive ? 0 : -1;
        if (muteButton) muteButton.tabIndex = isActive ? 0 : -1;
        if (!isActive) this.pauseVideo(slide.querySelector('video'));
      });
    }

    handleClick(event) {
      const selectButton = event.target.closest('.ndev-home-kol-card__select');
      if (selectButton) {
        this.activateSlide(selectButton.closest('.ndev-home-kol-carousel__slide'));
        return;
      }

      const control = event.target.closest('.ndev-home-kol-card__control');
      if (!control) return;
      const slide = control.closest('.ndev-home-kol-carousel__slide');
      if (!slide?.classList.contains('swiper-slide-active')) return;
      const video = slide.querySelector('video');
      if (!video) return;

      if (control.classList.contains('ndev-home-kol-card__control--mute')) {
        video.muted = !video.muted;
        this.updateVideoControls(slide, video);
        return;
      }

      if (video.paused) {
        this.pauseAllVideos(video);
        const playPromise = video.play();
        if (playPromise?.catch) playPromise.catch(() => this.updateVideoControls(slide, video));
      } else {
        this.pauseVideo(video);
      }
    }

    activateSlide(slide, speed) {
      if (!slide || !this.swiper) return;
      const realIndex = Number(slide.getAttribute('data-swiper-slide-index'));
      const transitionSpeed = speed ?? this.swiper.params.speed;

      if (Number.isFinite(realIndex) && typeof this.swiper.slideToLoop === 'function') {
        this.swiper.slideToLoop(realIndex, transitionSpeed);
        return;
      }

      const slideIndex = this.swiper.slides.indexOf(slide);
      if (slideIndex >= 0) this.swiper.slideTo(slideIndex, transitionSpeed);
    }

    handleBlockSelect(event) {
      if (!(event.target instanceof Element) || !this.contains(event.target)) return;
      this.activateSlide(event.target.closest('.ndev-home-kol-carousel__slide'), 0);
    }

    handleVideoState(event) {
      if (!(event.target instanceof HTMLVideoElement)) return;
      if (event.type === 'play') this.pauseAllVideos(event.target);
      if (event.type === 'ended') {
        this.pauseVideo(event.target);
        return;
      }
      const slide = event.target.closest('.ndev-home-kol-carousel__slide');
      if (slide) this.updateVideoControls(slide, event.target);
    }

    handleProgressInput(event) {
      if (!(event.target instanceof Element)) return;
      const progress = event.target.closest('.ndev-home-kol-card__progress');
      if (!progress) return;
      const video = progress.closest('.ndev-home-kol-carousel__slide')?.querySelector('video');
      if (!video || !Number.isFinite(video.duration) || video.duration <= 0) return;

      video.currentTime = video.duration * (progress.valueAsNumber / 100);
      this.updateVideoProgress(progress, video);
    }

    updateVideoControls(slide, video) {
      const controls = slide.querySelector('.ndev-home-kol-card__controls');
      const progress = slide.querySelector('.ndev-home-kol-card__progress');
      const playButton = slide.querySelector('.ndev-home-kol-card__control--play');
      const muteButton = slide.querySelector('.ndev-home-kol-card__control--mute');
      if (controls) controls.toggleAttribute('playing', !video.paused);
      if (progress) this.updateVideoProgress(progress, video);
      if (playButton) {
        playButton.setAttribute('aria-pressed', video.paused ? 'false' : 'true');
        playButton.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
      }
      if (muteButton) {
        muteButton.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
        muteButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      }
    }

    updateVideoProgress(progress, video) {
      const duration = Number.isFinite(video.duration) && video.duration > 0 ? video.duration : 0;
      const value = duration > 0 ? Math.min(100, Math.max(0, (video.currentTime / duration) * 100)) : 0;
      progress.value = String(value);
      progress.style.setProperty('--ndev-home-kol-progress', `${value}%`);
    }

    pauseVideo(video) {
      if (!video) return;
      video.pause();
      const slide = video.closest('.ndev-home-kol-carousel__slide');
      if (slide) this.updateVideoControls(slide, video);
    }

    pauseAllVideos(exceptVideo) {
      this.querySelectorAll('video').forEach((video) => {
        if (video !== exceptVideo) this.pauseVideo(video);
      });
    }

    dispose() {
      window.cancelAnimationFrame(this.updateFrame);
      window.cancelAnimationFrame(this.reinitializeFrame);
      this.panelObserver?.disconnect?.();
      this.visibilityObserver?.disconnect?.();
      this.pauseAllVideos?.();
      this.swiper?.destroy?.(true, true);

      if (this.listeners) {
        this.listeners.forEach(({ target, type, handler, options }) => target.removeEventListener(type, handler, options));
      }

      this.querySelectorAll?.('video').forEach((video) => {
        video.controls = true;
      });
      this.querySelectorAll?.('.ndev-home-kol-carousel__slide').forEach((slide) => {
        slide.removeAttribute('aria-current');
        slide.removeAttribute('inert');
        const selectButton = slide.querySelector('.ndev-home-kol-card__select');
        if (selectButton) {
          selectButton.hidden = false;
          selectButton.removeAttribute('tabindex');
        }
        slide.querySelector('.ndev-home-kol-card__fallback-link')?.removeAttribute('tabindex');
      });

      this.removeAttribute?.('enhanced');
      this.classList?.remove('ndev-home-kol-carousel--single');
      if (this.platformSingleClass) this.classList?.remove(this.platformSingleClass);
      this.listeners = [];
      this.slides = [];
      this.swiper = null;
      this.panelObserver = null;
      this.visibilityObserver = null;
      this.updateFrame = 0;
      this.reinitializeFrame = 0;
    }
  }

  if (!customElements.get('ndev-home-kol-carousel')) {
    customElements.define('ndev-home-kol-carousel', NdevHomeKolCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-instagram-media-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__ndevInstagramMediaCardPlayerInited) return;
    window.__ndevInstagramMediaCardPlayerInited = true;

    const mobileMQ = () => window.matchMedia && window.matchMedia('(max-width: 1023px)').matches;

    function getVideoEl(card, index) {
      const list = card.querySelectorAll(`[node-name="video_${index}"]`);
      if (!list || list.length === 0) return null;

      // ndev-lazy-video 可能会输出 pc/mobile 两个节点
      if (list.length === 1) {
        const one = list[0];
        return one.tagName === 'VIDEO' ? one : (one.querySelector('video') || null);
      }

      const mobile = mobileMQ();
      const pick = Array.from(list).find((el) =>
        mobile ? el.classList.contains('mobile-done') : el.classList.contains('pc-done')
      );
      const node = pick || list[0];
      return node.tagName === 'VIDEO' ? node : (node.querySelector('video') || null);
    }

    function getBar(card, index) {
      return card.querySelector(`[node-name="bar_${index}"]`) || null;
    }

    function setBarProgress(bar, ratio) {
      if (!bar) return;
      const clamped = Math.max(0, Math.min(1, ratio));
      const total = 301.44;
      bar.style.strokeDashoffset = String(total * (1 - clamped));
    }

    function toggleIcons(card, index, isPlaying) {
      const playIcon = card.querySelector(`[node-name="play_${index}"]`);
      const pauseIcon = card.querySelector(`[node-name="pause_${index}"]`);
      if (playIcon) playIcon.classList.toggle('hide', isPlaying);
      if (pauseIcon) pauseIcon.classList.toggle('hide', !isPlaying);
    }

    function playVideo(card, index) {
      const video = getVideoEl(card, index);
      if (!video) return;
      card.classList.add('play');
      card.classList.add('off');
      toggleIcons(card, index, true);

      try {
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      } catch (_) {}
    }

    function pauseVideo(card, index) {
      const video = getVideoEl(card, index);
      if (!video) return;
      try {
        video.pause();
      } catch (_) {}
      card.classList.remove('play');
      card.classList.remove('off');
      toggleIcons(card, index, false);
    }

    function resetVideoUI(card, index) {
      const video = getVideoEl(card, index);
      const bar = getBar(card, index);
      card.classList.remove('play');
      card.classList.remove('off');
      toggleIcons(card, index, false);
      setBarProgress(bar, 0);
      if (video) {
        try {
          video.currentTime = 0;
        } catch (_) {}
      }
    }

    function playEmbed(card, index) {
      const codeEl = card.querySelector('[data-ndev-instagram-embed-code]');
      const wrap = card.querySelector('[data-ndev-instagram-embed]');
      if (!codeEl || !wrap) return;

      let code = '';
      try {
        code = JSON.parse(codeEl.textContent || '""') || '';
      } catch (_) {
        code = '';
      }
      if (!code) return;

      wrap.innerHTML = code;
      const iframe = wrap.querySelector('iframe');
      if (!iframe) return;
      const src = iframe.getAttribute('src') || '';
      const urlChar = src.includes('?') ? '&' : '?';
      iframe.setAttribute('src', `${src}${urlChar}autoplay=1&v=${Date.now()}`);

      card.classList.add('off');
    }

    // 使用事件委托，避免重复绑定 & 支持多实例
    document.addEventListener('click', (ev) => {
      const btn = ev.target && ev.target.closest && ev.target.closest('[node-name="play"]');
      if (!btn) return;

      const card = btn.closest('[data-ndev-instagram-media-card]');
      if (!card) return;

      ev.stopPropagation();
      const index = Number(btn.dataset.index || 0);

      if (btn.dataset.type === 'embed') {
        playEmbed(card, index);
        return;
      }

      // video toggle
      if (card.classList.contains('play')) pauseVideo(card, index);
      else playVideo(card, index);
    });

    // 进度条：用 timeupdate 同步即可
    document.addEventListener('timeupdate', (ev) => {
      const video = ev.target;
      if (!video || video.tagName !== 'VIDEO') return;

      const card = video.closest && video.closest('[data-ndev-instagram-media-card]');
      if (!card) return;

      const index = Number(card.querySelector('[node-name="play"]')?.dataset?.index || 0);
      const bar = getBar(card, index);
      const ratio = video.duration ? (video.currentTime / video.duration) : 0;
      setBarProgress(bar, ratio);
    }, true);

    // 播放结束时复位 UI（否则会停留在 pause icon）
    document.addEventListener('ended', (ev) => {
      const video = ev.target;
      if (!video || video.tagName !== 'VIDEO') return;
      const card = video.closest && video.closest('[data-ndev-instagram-media-card]');
      if (!card) return;
      const index = Number(card.querySelector('[node-name="play"]')?.dataset?.index || 0);
      resetVideoUI(card, index);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-klaviyo-api"] && !Shopify.designMode) return;
  try {
    (function() {
  // 防止重复初始化
  if (window.$klaviyo) {
    window.dispatchEvent(new Event('ndev:klaviyo-api-ready'));
    return;
  }

  /**
   * Klaviyo API 基础配置
   */
  const KLAVIYO_CONFIG = {
    baseUrl: 'https://a.klaviyo.com',
    revision: '2025-10-15',
    headers: {
      accept: 'application/json',
      revision: '2025-10-15',
      'content-type': 'application/json'
    }
  };

  /**
   * 通用的 Klaviyo API 请求处理函数
   * @param {string} url - 请求 URL
   * @param {Object} body - 请求体
   * @param {string} defaultErrorMessage - 默认错误消息
   * @param {AbortSignal} [signal] - 可选的请求取消信号
   * @returns {Promise<Object>} - 返回格式: { success: boolean, data?: Object, error?: string, aborted?: boolean }
   */
  async function klaviyoRequest(url, body, defaultErrorMessage = 'Request failed', signal) {
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: KLAVIYO_CONFIG.headers,
        body: JSON.stringify(body),
        signal: signal
      });

      // 获取响应文本，检查是否为空
      const responseText = await response.text();

      if (!response.ok) {
        // 尝试解析错误响应
        let errorData = {};
        try {
          if (responseText) {
            errorData = JSON.parse(responseText);
          }
        } catch (e) {
          // 如果无法解析 JSON，使用原始文本
          errorData = { message: responseText || `HTTP ${response.status}: ${response.statusText}` };
        }

        return {
          success: false,
          error: errorData.message || errorData.detail || errorData.errors?.[0]?.detail || defaultErrorMessage
        };
      }

      // 如果响应为空，返回空对象
      let data = {};
      if (responseText && responseText.trim() !== '') {
        // 尝试解析 JSON 响应
        try {
          data = JSON.parse(responseText);
        } catch (e) {
          // 如果无法解析，使用空对象（成功响应可能没有 body）
          data = {};
        }
      }

      return {
        success: true,
        data: data
      };
    } catch (error) {
      if (error?.name === 'AbortError') {
        return {
          success: false,
          aborted: true,
          error: 'Request aborted'
        };
      }

      // 捕获所有未预期的错误
      return {
        success: false,
        error: error.message || 'An unexpected error occurred'
      };
    }
  }

  /**
   * 创建订阅
   * @param {Object} config - 配置对象
   * @param {string} config.email - 用户邮箱（必填）
   * @param {string} config.apiKey - Klaviyo API Key/Company ID（必填）
   * @param {string} config.listId - Klaviyo List ID（必填）
   * @param {Object} config.attributes - 额外的用户属性（可选）
   * @param {Object} config.ga4 - GA4 埋点配置（可选）
   * @param {string} config.ga4.event - GA4 事件名；不传则不上报
   * @param {string} config.ga4.module - 模块名称
   * @param {string} config.ga4.btn - 按钮名称
   * @param {boolean} [config.emitSuccess=true] - 是否触发 KLAVIYO.SUBSCRIBE.SUCCESS 全局事件
   * @param {AbortSignal} [config.signal] - 可选的请求取消信号
   * @returns {Promise<Object>} - 返回格式: { success: boolean, data?: Object, error?: string, aborted?: boolean }
   */
  async function subscribe(config) {
    const { email, apiKey, listId, attributes = {}, ga4 = {}, emitSuccess = true, signal } = config;

    if (!email || !apiKey || !listId) {
      return {
        success: false,
        error: 'Klaviyo Subscribe: email, apiKey, and listId are required'
      };
    }

    const url = `${KLAVIYO_CONFIG.baseUrl}/client/subscriptions?company_id=${apiKey}`;
    const body = {
      data: {
        type: 'subscription',
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        },
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                ...attributes
              }
            }
          }
        }
      }
    };

    // 使用通用请求处理函数
    const result = await klaviyoRequest(url, body, 'Subscription failed', signal);

    // 如果请求成功，按配置触发事件
    if (result.success) {
      // 触发全局订阅成功事件
      if (emitSuccess && window.$narwal?.emit) {
        window.$narwal.emit('KLAVIYO.SUBSCRIBE.SUCCESS', {
          id: listId,
          company_id: apiKey,
          email: email
        });
      }

      // 触发 GA4 订阅成功事件
      const ga4Event = ga4.event ? String(ga4.event).trim() : '';

      if (window.$narwal?.report && ga4Event) {
        window.$narwal.report({
          event: ga4Event,
          params: {
            page: 'self',
            btn: ga4.btn || 'subscribe',
            module: ga4.module || '',
            email: email,
            list_id: listId
          }
        });
      }
    }

    return result;
  }

  /**
   * 更新用户 Profile
   * @param {Object} config - 配置对象
   * @param {string} config.email - 用户邮箱（必填）
   * @param {string} config.apiKey - Klaviyo API Key/Company ID（必填）
   * @param {Object} config.properties - 要更新的属性（例如 { tag: 'TAG CES' }）
   * @param {Object} config.attributes - 额外的用户属性（可选，例如 first_name, last_name 等）
   * @param {AbortSignal} [config.signal] - 可选的请求取消信号
   * @returns {Promise<Object>} - 返回格式: { success: boolean, data?: Object, error?: string, aborted?: boolean }
   */
  async function updateProfile(config) {
    const { email, apiKey, properties = {}, attributes = {}, signal } = config;

    if (!email || !apiKey) {
      return {
        success: false,
        error: 'Klaviyo Update Profile: email and apiKey are required'
      };
    }

    const url = `${KLAVIYO_CONFIG.baseUrl}/client/profiles?company_id=${apiKey}`;
    const body = {
      data: {
        type: 'profile',
        attributes: {
          email: email,
          ...attributes
        }
      }
    };

    // 如果有 properties，添加到 attributes 中
    if (properties && Object.keys(properties).length > 0) {
      body.data.attributes.properties = properties;
    }

    // 使用通用请求处理函数
    return await klaviyoRequest(url, body, 'Update profile failed', signal);
  }

  /**
   * 订阅并更新 Profile（组合操作）
   * @param {Object} config - 配置对象
   * @param {string} config.email - 用户邮箱（必填）
   * @param {string} config.apiKey - Klaviyo API Key/Company ID（必填）
   * @param {string} config.listId - Klaviyo List ID（必填）
   * @param {Object} config.properties - 要更新的属性（可选）
   * @param {Object} config.attributes - 额外的用户属性（可选）
   * @param {Object} config.ga4 - GA4 埋点配置（可选）
   * @param {string} config.ga4.event - GA4 事件名；不传则不上报
   * @param {string} config.ga4.module - 模块名称
   * @param {string} config.ga4.btn - 按钮名称
   * @param {boolean} [config.emitSuccess=true] - 是否触发 KLAVIYO.SUBSCRIBE.SUCCESS 全局事件
   * @param {AbortSignal} [config.signal] - 可选的请求取消信号
   * @returns {Promise<Object>} - 返回格式: { success: boolean, subscribe?: Object, update?: Object, error?: string }
   */
  async function subscribeAndUpdateProfile(config) {
    const { email, apiKey, listId, properties = {}, attributes = {}, ga4 = {}, emitSuccess = true, signal } = config;

    // 先订阅
    const subscribeResult = await subscribe({ email, apiKey, listId, attributes, ga4, emitSuccess, signal });

    // 如果订阅失败，直接返回
    if (!subscribeResult.success) {
      return subscribeResult;
    }

    // 如果有 properties，再更新 profile
    if (properties && Object.keys(properties).length > 0) {
      const updateResult = await updateProfile({ email, apiKey, properties, attributes, signal });

      // 如果更新失败，返回订阅成功但更新失败的结果
      if (!updateResult.success) {
        return {
          success: false,
          subscribe: subscribeResult,
          update: updateResult,
          error: updateResult.error
        };
      }

      return {
        success: true,
        subscribe: subscribeResult,
        update: updateResult
      };
    }

    return {
      success: true,
      subscribe: subscribeResult
    };
  }

  /**
   * 邮箱格式验证
   * @param {string} email - 要验证的邮箱
   * @returns {boolean} - 是否有效
   */
  function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  /**
   * 解析 Klaviyo API 错误信息
   * @param {Error} error - 错误对象
   * @param {Object} messages - 自定义错误消息配置（可选）
   * @param {string} messages.alreadyRegistered - 邮箱已注册提示
   * @param {string} messages.invalid - 邮箱无效提示
   * @param {string} messages.default - 默认错误提示
   * @returns {string} - 用户友好的错误消息
   */
  function parseErrorMessage(error, messages = {}) {
    // 默认错误消息
    const defaultMessages = {
      alreadyRegistered: 'This email is already registered',
      invalid: 'This email is invalid',
      default: 'Subscription failed. Please try again.'
    };

    // 合并自定义消息
    const errorMessages = { ...defaultMessages, ...messages };

    // 如果没有错误消息，返回默认错误
    if (!error || !error.message) {
      return errorMessages.default;
    }

    const errorMsg = error.message.toLowerCase();

    // 检查是否为已存在的邮箱
    if (errorMsg.includes('already') || errorMsg.includes('exists')) {
      return errorMessages.alreadyRegistered;
    }

    // 检查是否为无效邮箱
    if (errorMsg.includes('invalid')) {
      return errorMessages.invalid;
    }

    // 返回原始错误消息或默认消息
    return error.message || errorMessages.default;
  }

  // 导出到全局
  window.$klaviyo = {
    subscribe,
    updateProfile,
    subscribeAndUpdateProfile,
    validateEmail,
    parseErrorMessage
  };
  window.dispatchEvent(new Event('ndev:klaviyo-api-ready'));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-media-video"] && !Shopify.designMode) return;
  try {
    (function () {
    var ROOT_SELECTOR = '[data-ndev-media]';
    var INIT_ATTR = 'data-ndev-media-init';

    function toBool(raw) {
      return raw === true || raw === 'true' || raw === '1';
    }

    function isMobile() {
      return window.matchMedia && window.matchMedia('(max-width: 1023px)').matches;
    }

    function getVisibleVideo(root) {
      var selector = isMobile() ? '.show-mb video.ndev-media__video' : '.show-pc video.ndev-media__video';
      return root.querySelector(selector);
    }

    function isInActiveTabPanel(root) {
      var bannerSlide = root.closest('ndev-banner-slide');
      if (
        bannerSlide
        && (
          bannerSlide.hasAttribute('inert')
          || bannerSlide.getAttribute('aria-hidden') === 'true'
          || window.matchMedia('(prefers-reduced-motion: reduce)').matches
        )
      ) {
        return false;
      }

      // 检查 ndev-cpi-tabs 面板
      var tabPanel = root.closest('.ndev-cpi-tabs__panel') || root.closest('.ndev-x30-sweep-tabs__image-panel');
      if (tabPanel) {
        return tabPanel.classList.contains('active');
      }
      return true;
    }

    function ensureInlineVideoAttrs(video) {
      if (!video) return;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    }

    function safePause(video, resetOnResume) {
      if (!video) return;
      try {
        video.pause();
      } catch (e) {}
      if (resetOnResume) {
        try {
          video.currentTime = 0;
        } catch (e) {}
      }
    }

    function safePlay(video) {
      if (!video) return;
      try {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (e) {}
    }

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR)) return;

      var allVideos = root.querySelectorAll('video');
      if (!allVideos.length) {
        root.setAttribute(INIT_ATTR, '1');
        return;
      }

      allVideos.forEach(ensureInlineVideoAttrs);

      var settingsScript = root.querySelector('script[data-ndev-media-settings]');
      if (!settingsScript) {
        root.setAttribute(INIT_ATTR, '1');
        return;
      }

      var settings = JSON.parse(settingsScript.textContent);
      var autoplayEnabled = toBool(settings.autoplay);
      var loopEnabled = toBool(settings.loop);
      var resetOnResume = toBool(settings.reset_on_resume);
      var threshold = parseFloat(settings.threshold);
      if (isNaN(threshold) || threshold < 0 || threshold > 1) threshold = 0.35;
      var toggleEvent = settings.toggle_event || null;

      allVideos.forEach(function (v) { v.loop = loopEnabled; });

      var inView = false;

      function sync() {
        var active = isInActiveTabPanel(root);
        var eligible = inView && active && !document.hidden;
        var video = getVisibleVideo(root);

        if (!eligible) {
          allVideos.forEach(function (v) { safePause(v, resetOnResume); });
          return;
        }

        allVideos.forEach(function (v) {
          if (v !== video) safePause(v, resetOnResume);
        });

        if (autoplayEnabled && video) {
          if (!video.muted) video.muted = true;
          safePlay(video);
        }
      }

      root.__ndevMediaSync = sync;

      var observer = null;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.target !== root) return;
              inView = !!entry.isIntersecting;
            });
            sync();
          },
          { root: null, rootMargin: '0px 0px 0px 0px', threshold }
        );
        observer.observe(root);
        root.__ndevMediaObserver = observer;
      } else {
        inView = true;
        sync();
      }

      var handleVisibility = function () {
        sync();
      };
      document.addEventListener('visibilitychange', handleVisibility);
      root.__ndevMediaVisibilityHandler = handleVisibility;

      var tabsRoot = root.closest('.ndev-closable-product-intro__tabs-block');
      if (tabsRoot && !tabsRoot.getAttribute('data-ndev-media-tabs-bound')) {
        tabsRoot.setAttribute('data-ndev-media-tabs-bound', '1');
        var titles = tabsRoot.querySelector('.ndev-cpi-tabs__titles');
        if (titles) {
          titles.addEventListener('click', function () {
            setTimeout(function () {
              initAll(tabsRoot);
              tabsRoot.querySelectorAll(ROOT_SELECTOR).forEach(function (r) {
                if (typeof r.__ndevMediaSync === 'function') r.__ndevMediaSync();
              });
            }, 0);
          });
        }
      }

      if (toggleEvent) {
        var handleToggle = function (e) {
          var action = (e.detail && e.detail.action) || 'toggle';
          if (action === 'pause') {
            allVideos.forEach(function (item) { safePause(item, resetOnResume); });
            return;
          }

          var video = getVisibleVideo(root);
          if (!video) return;
          if (action === 'play') {
            allVideos.forEach(function (item) {
              if (item !== video) safePause(item, resetOnResume);
            });
            if (!video.muted) video.muted = true;
            safePlay(video);
          } else if (action === 'toggle') {
            if (video.paused) {
              allVideos.forEach(function (item) {
                if (item !== video) safePause(item, resetOnResume);
              });
              if (!video.muted) video.muted = true;
              safePlay(video);
            } else {
              allVideos.forEach(function (item) { safePause(item, resetOnResume); });
            }
          }
        };
        root.__ndevMediaToggleHandler = handleToggle;
        root.__ndevMediaToggleEvent = toggleEvent;
        document.addEventListener(toggleEvent, handleToggle);
      }

      root.setAttribute(INIT_ATTR, '1');
    }

    function destroyOne(root) {
      if (!root) return;

      if (root.__ndevMediaObserver) {
        try { root.__ndevMediaObserver.disconnect(); } catch (e) {}
        root.__ndevMediaObserver = null;
      }

      if (root.__ndevMediaVisibilityHandler) {
        try { document.removeEventListener('visibilitychange', root.__ndevMediaVisibilityHandler); } catch (e) {}
        root.__ndevMediaVisibilityHandler = null;
      }

      if (root.__ndevMediaToggleHandler && root.__ndevMediaToggleEvent) {
        try { document.removeEventListener(root.__ndevMediaToggleEvent, root.__ndevMediaToggleHandler); } catch (e) {}
        root.__ndevMediaToggleHandler = null;
        root.__ndevMediaToggleEvent = null;
      }

      root.__ndevMediaSync = null;
      root.removeAttribute(INIT_ATTR);
    }

    function initAll(scope) {
      var base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    function destroyAll(scope) {
      var base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(destroyOne);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e && e.target ? e.target : null);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      destroyAll(e && e.target ? e.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-modal"] && !Shopify.designMode) return;
  try {
    class NdevModal extends BaseElement {
    init() {
      this.triggerId = this.id;
      this.dialog = this.querySelector('.ndev-modal__dialog');
      this.body = this.querySelector('[data-ndev-modal-body]');
      this.content = this.querySelector('[data-ndev-modal-content]');
      this.url = this.getAttribute('url') || '';
      this.view = this.getAttribute('view') || '';
      this.termsCloseOnMask = this.getAttribute('close-on-mask') !== 'false';
      this.errorLabel = this.getAttribute('error-label') || '';
      this.isClosing = false;
      this.loadToken = 0;
      this.iframe = this.querySelector('iframe');

      this.onDocumentClick = (event) => this.handleDocumentClick(event);
      this.onDialogClick = (event) => {
        if (event.target === this.dialog && this.termsCloseOnMask) this.close();
      };
      this.onDialogCancel = (event) => {
        event.preventDefault();
        this.close();
      };
      this.onResize = () => this.syncHeight();

      document.addEventListener('click', this.onDocumentClick);
      this.dialog.addEventListener('click', this.onDialogClick);
      this.dialog.addEventListener('cancel', this.onDialogCancel);
      window.addEventListener('resize', this.onResize);
    }

    handleDocumentClick(event) {
      const trigger = event.target.closest('[data-ndev-modal-open]');
      if (trigger) {
        if (trigger.getAttribute('data-ndev-modal-open') !== this.triggerId) return;
        if (trigger.tagName === 'A') event.preventDefault();
        this.open();
        return;
      }

      const closeButton = event.target.closest('[data-ndev-modal-close]');
      if (closeButton && this.contains(closeButton)) {
        this.close();
      }
    }

    open() {
      if (!this.dialog) return;

      if (typeof this.dialog.showModal === 'function') {
        if (!this.dialog.open) this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }

      if (!this.url || !this.content) return;

      // 已注入过：内容已就绪则直接展示，否则继续等待其测量完成
      if (this.content.dataset.loaded === 'true') {
        if (this.iframe && this.iframe.getAttribute('data-sized') === 'true') return;
        this.setBusy(true);
        this.startSizing();
        return;
      }

      const target = new URL(this.url, window.location.origin);
      if (target.origin === window.location.origin) {
        this.loadSource(target);
      } else {
        this.loadExternal(target.href);
      }
    }

    close() {
      const dialog = this.dialog;
      if (!dialog || !dialog.open || this.isClosing) return;

      this.releaseObserver();
      this.clearLoadTimers();

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        dialog.close();
        return;
      }

      this.isClosing = true;
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        this.isClosing = false;
        dialog.removeEventListener('animationend', onAnimationEnd);
        dialog.classList.remove('ndev-modal--closing');
        if (dialog.open) dialog.close();
      };
      const onAnimationEnd = (event) => {
        if (event.target === dialog) finish();
      };

      dialog.addEventListener('animationend', onAnimationEnd);
      dialog.classList.add('ndev-modal--closing');
      window.setTimeout(finish, 500);
    }

    setBusy(busy) {
      if (this.body) this.body.setAttribute('aria-busy', busy ? 'true' : 'false');
      if (!this.dialog) return;
      if (busy) this.dialog.setAttribute('data-loading', 'true');
      else this.dialog.removeAttribute('data-loading');
    }

    // 移除 loading 与临时处理：仅在 iframe 真正可展示（或确认不可测量）后调用
    finishLoading() {
      this.clearLoadTimers();
      this.setBusy(false);
    }

    clearLoadTimers() {
      if (this.loadTimer) {
        window.clearTimeout(this.loadTimer);
        this.loadTimer = null;
      }
    }

    showStatus(url) {
      const status = this.querySelector('[data-ndev-modal-status]');
      if (!status) return;
      status.textContent = '';
      status.append(document.createTextNode((this.errorLabel || '') + ' '));
      if (url) {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = url;
        status.append(link);
      }
      status.hidden = false;
    }

    clearStatus() {
      const status = this.querySelector('[data-ndev-modal-status]');
      if (!status) return;
      status.hidden = true;
      status.textContent = '';
    }

    createIframe(external) {
      if (this.iframe) return this.iframe;

      const iframe = document.createElement('iframe');
      const label = this.dialog.getAttribute('aria-label');
      if (label) iframe.title = label;

      if (external) {
        // 跨域无法取源，直接作为 src；内容不可测量，内部自行滚动
        iframe.setAttribute('data-external', 'true');
        iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox');
      } else {
        iframe.setAttribute('sandbox', 'allow-same-origin allow-popups allow-popups-to-escape-sandbox');
      }

      if (this.content) {
        this.content.textContent = '';
        this.content.append(iframe);
      }
      this.iframe = iframe;
      return iframe;
    }

    loadExternal(url) {
      const iframe = this.createIframe(true);
      if (!iframe || !this.content || this.content.dataset.loaded === 'true') return;

      this.setBusy(true);
      iframe.addEventListener('load', () => this.finishLoading(), { once: true });
      iframe.src = url;
      this.content.dataset.loaded = 'true';

      // 跨域内容无法测量，加载事件不可靠时也要收掉 loading
      this.loadTimer = window.setTimeout(() => this.finishLoading(), 8000);
    }

    // 把宿主页已加载的同源样式表复制进片段，保证弹窗内样式与页面一致
    inheritHostStyles(doc) {
      const head = doc.head;
      if (!head) return;
      const present = new Set(
        Array.from(head.querySelectorAll('link[rel="stylesheet"]')).map((link) => link.getAttribute('href'))
      );
      document.querySelectorAll('link[rel="stylesheet"][href]').forEach((link) => {
        const href = link.getAttribute('href');
        if (!href || present.has(href)) return;
        let resolved;
        try {
          resolved = new URL(link.href, window.location.href);
        } catch (error) {
          return;
        }
        if (resolved.origin !== window.location.origin) return;
        present.add(href);
        const clone = doc.createElement('link');
        clone.rel = 'stylesheet';
        clone.href = href;
        head.append(clone);
      });
    }

    async loadSource(target) {
      if (!this.content) return;

      const fetchUrl = new URL(target.href);
      if (this.view) fetchUrl.searchParams.set('view', this.view);

      this.setBusy(true);
      const token = ++this.loadToken;

      try {
        const response = await fetch(fetchUrl.toString(), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!response.ok) throw new Error('HTTP ' + response.status);

        const html = await response.text();
        if (token !== this.loadToken) return;

        // 缺少内容标记（例如该资源没有对应 view 模板、返回了完整页面）时不注入源码
        if (!html.trim() || html.indexOf('data-ndev-modal-content') === -1) {
          this.showStatus(fetchUrl.toString());
          return;
        }

        const doc = new DOMParser().parseFromString(html, 'text/html');
        this.inheritHostStyles(doc);

        // 弹窗自带标题时，去掉片段内的页面标题，避免标题重复；
        // 无标题栏（show_title: false）时保留页面标题作为内容上下文
        if (this.querySelector('.ndev-modal__title')) {
          doc.querySelector('.ndev-modal-content__title')?.remove();
        }

        // 宿主显式强制某一种配色（color-scheme: dark）时，片段同步为同一种
        const hostScheme = getComputedStyle(this.dialog || document.documentElement).colorScheme || '';
        if (/\bdark\b/.test(hostScheme) && !/\blight\b/.test(hostScheme)) {
          doc.documentElement.style.colorScheme = 'dark';
        }

        const iframe = this.createIframe(false);
        if (!iframe) return;
        iframe.srcdoc = '<!doctype html>' + doc.documentElement.outerHTML;
        this.content.dataset.loaded = 'true';
        this.clearStatus();

        // 注入完成后由测量（轮询 + load + 观察器）决定何时展示与收掉 loading
        this.startSizing();
      } catch (error) {
        if (token !== this.loadToken) return;
        this.showStatus(fetchUrl.toString());
        this.finishLoading();
      }
    }

    // 注入后测量：立即尝试 + load 事件 + 轮询，超时降级为固定高度
    startSizing() {
      const iframe = this.iframe;
      if (!iframe) {
        this.finishLoading();
        return;
      }

      if (this.trySize()) return;

      if (!iframe.__ndevModalLoadBound) {
        iframe.addEventListener('load', () => this.trySize());
        iframe.__ndevModalLoadBound = true;
      }

      this.clearLoadTimers();
      const LIMIT = 8000;
      const STEP = 120;
      let elapsed = 0;
      const tick = () => {
        if (this.trySize()) return;
        elapsed += STEP;
        if (elapsed >= LIMIT) {
          this.fallbackToFixedHeight();
          return;
        }
        this.loadTimer = window.setTimeout(tick, STEP);
      };
      this.loadTimer = window.setTimeout(tick, STEP);
    }

    trySize() {
      if (!this.syncHeight()) return false;
      this.finishLoading();
      return true;
    }

    // 测量内容高度并展示；about:blank 阶段（无内容标记）不参与测量
    syncHeight() {
      const iframe = this.iframe;
      if (!iframe || iframe.getAttribute('data-external') === 'true') return false;

      let doc;
      try {
        doc = iframe.contentDocument;
      } catch (error) {
        return false;
      }
      if (!doc || !doc.body) return false;

      const target = doc.querySelector('[data-ndev-modal-content]');
      if (!target) return false;

      const height = Math.ceil(
        Math.max(doc.documentElement.scrollHeight, target.getBoundingClientRect().height)
      );
      if (!height || height < 24) return false;

      const next = height + 'px';
      if (iframe.style.height !== next) iframe.style.height = next;
      iframe.setAttribute('data-sized', 'true');
      iframe.removeAttribute('data-fallback');

      // 尺寸与内容一致：关掉片段内部滚动，滚动统一交给弹窗内容区（避免双滚动条）
      try {
        doc.documentElement.style.overflow = 'hidden';
      } catch (error) {
        /* 跨域内容忽略 */
      }

      this.observeTarget(doc, target);
      return true;
    }

    observeTarget(doc, target) {
      const iframe = this.iframe;
      if (!iframe || iframe.__ndevModalObserver || typeof ResizeObserver !== 'function') return;
      const observer = new ResizeObserver(() => this.syncHeight());
      observer.observe(target);
      iframe.__ndevModalObserver = observer;
    }

    // 测量失败：降级为固定高度，并保留片段内部滚动，确保内容仍然可达
    fallbackToFixedHeight() {
      const iframe = this.iframe;
      if (iframe && !iframe.getAttribute('data-sized') && iframe.getAttribute('data-external') !== 'true') {
        iframe.setAttribute('data-fallback', 'true');
        try {
          const doc = iframe.contentDocument;
          if (doc) doc.documentElement.style.overflow = '';
        } catch (error) {
          /* 跨域内容忽略 */
        }
      }
      this.finishLoading();
    }

    releaseObserver() {
      const iframe = this.iframe;
      if (!iframe || !iframe.__ndevModalObserver) return;
      iframe.__ndevModalObserver.disconnect();
      delete iframe.__ndevModalObserver;
    }

    dispose() {
      document.removeEventListener('click', this.onDocumentClick);
      window.removeEventListener('resize', this.onResize);
      if (this.dialog) {
        this.dialog.removeEventListener('click', this.onDialogClick);
        this.dialog.removeEventListener('cancel', this.onDialogCancel);
        if (this.dialog.open) this.dialog.close();
      }
      this.releaseObserver();
      this.clearLoadTimers();
    }
  }

  if (!customElements.get('ndev-modal')) {
    customElements.define('ndev-modal', NdevModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-overlay-manager"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.$ndevOverlay) return;

    const STATE = {
      count: 0,
      overlayEl: null,
      prevOverflow: null,
    };

    function ensureOverlay() {
      if (STATE.overlayEl && document.body.contains(STATE.overlayEl)) return STATE.overlayEl;
      const existing = document.querySelector('.ndev-global-overlay[data-ndev-global-overlay="1"]');
      if (existing) {
        STATE.overlayEl = existing;
        return existing;
      }

      const overlay = document.createElement('div');
      overlay.className = 'ndev-global-overlay';
      overlay.setAttribute('data-ndev-global-overlay', '1');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('data-visible', '0');
      overlay.innerHTML = '<div class="ndev-global-overlay__spinner" aria-hidden="true"></div>';
      document.body.appendChild(overlay);
      STATE.overlayEl = overlay;
      return overlay;
    }

    function lockScroll() {
      if (STATE.count !== 0) return;
      try {
        const body = document.body;
        if (!body) return;
        STATE.prevOverflow = body.style.overflow || '';
        body.style.overflow = 'hidden';
      } catch (e) {}
    }

    function unlockScroll() {
      if (STATE.count !== 0) return;
      try {
        const body = document.body;
        if (!body) return;
        body.style.overflow = STATE.prevOverflow || '';
      } catch (e) {}
      STATE.prevOverflow = null;
    }

    function showOverlay(opts) {
      const overlay = ensureOverlay();
      overlay.setAttribute('data-visible', '1');
      if (opts && opts.ariaLabel) overlay.setAttribute('aria-label', String(opts.ariaLabel));
    }

    function hideOverlay() {
      const overlay = ensureOverlay();
      overlay.setAttribute('data-visible', '0');
      overlay.removeAttribute('aria-label');
    }

    function lock(options) {
      const opts = options || {};
      const useLockScroll = opts.lockScroll !== false;
      if (useLockScroll) lockScroll();
      STATE.count += 1;
      showOverlay(opts);

      let released = false;
      return function unlockFn() {
        if (released) return;
        released = true;
        unlock();
      };
    }

    function unlock() {
      STATE.count = Math.max(0, STATE.count - 1);
      if (STATE.count !== 0) return;
      hideOverlay();
      unlockScroll();
    }

    function getCount() {
      return STATE.count || 0;
    }

    window.$ndevOverlay = {
      lock,
      unlock,
      getCount,
      ensureOverlay,
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-product-remarks-mobile"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const marqueeContainers = document.querySelectorAll('.ndev-marquee-container');

    marqueeContainers.forEach(container => {
      const scrollEl = container.querySelector('.ndev-marquee-scroll');

      // 点击链接：不触发展开/收起。收起态先暂停动画，等待跳转；展开态直接跳转即可。
      container.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', (e) => {
          e.stopPropagation();
          if (!container.classList.contains('expanded')) {
            container.classList.add('paused');
            if (scrollEl) scrollEl.style.animationPlayState = 'paused';
          }
          // 不阻止默认行为，让浏览器正常跳转
        });
      });

      // 点击容器（非链接区域）：展开/收起
      container.addEventListener('click', function(e) {
        if (e.target?.target?.closest('a')) return;
        this.classList.toggle('expanded');

        // 展开时确保恢复动画；收起时保持原动画逻辑（除非用户点过链接触发暂停）
        if (this.classList.contains('expanded')) {
          this.classList.remove('paused');
          if (scrollEl) scrollEl.style.animationPlayState = '';
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-product-remarks"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const remarksContainers = document.querySelectorAll('.ndev-product-remarks');

    remarksContainers.forEach(container => {
      const content = container.querySelector('.ndev-product-remarks-content');
      const toggleBtn = container.querySelector('.ndev-product-remarks-toggle');
      const toggleText = toggleBtn.querySelector('.ndev-product-remarks-toggle__text');

      if (!content || !toggleBtn) return;

      // 检查内容高度是否超过 max-height
      // 需要等待 CSS 生效和内容渲染
      const checkHeight = () => {
        // 用 clientHeight / scrollHeight 做判断更稳（避免部分浏览器 computed maxHeight = none/NaN）
        const isExpanded = content.classList.contains('expanded');
        if (isExpanded) {
          toggleBtn.style.display = 'inline-flex';
          return;
        }

        const isOverflowing = content.scrollHeight > content.clientHeight + 1; // +1 容错
        toggleBtn.style.display = isOverflowing ? 'inline-flex' : 'none';
      };

      // 初始检查
      requestAnimationFrame(checkHeight);
      window.addEventListener('load', checkHeight, { once: true });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(checkHeight).catch(() => {});
      }
      // 应对可能的布局变化（如图片加载）
      window.addEventListener('resize', checkHeight);

      toggleBtn.addEventListener('click', () => {
        const isExpanded = content.classList.contains('expanded');
        const viewMoreText = toggleBtn.dataset.viewMore || 'Afficher plus';
        const viewLessText = toggleBtn.dataset.viewLess || 'Afficher moins';

        if (isExpanded) {
          content.classList.remove('expanded');
          toggleBtn.classList.remove('expanded');
          toggleText.textContent = viewMoreText;
        } else {
          content.classList.add('expanded');
          toggleBtn.classList.add('expanded');
          toggleText.textContent = viewLessText;
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-quantity-selector"] && !Shopify.designMode) return;
  try {
    // 全局数量选择器事件处理
  (function() {
    if (window.ndevQuantitySelectorInitialized) return;
    window.ndevQuantitySelectorInitialized = true;

    // 辅助函数：触发变更事件
    function dispatchChange(selector, newQty, oldQty, action) {
      const lineIndex = selector.getAttribute('data-line');
      const variantId = selector.getAttribute('data-variant-id');
      const detail = {
        lineIndex: parseInt(lineIndex, 10),
        variantId: variantId,
        oldQuantity: oldQty,
        newQuantity: newQty,
        action: action,
        selector: selector
      };

      selector.dispatchEvent(new CustomEvent('quantity:change', {
        bubbles: true,
        composed: true,
        detail: detail
      }));
      $narwal.emit('quantity:change', detail);
    }

    // 辅助函数：触发数量受限事件（例如达到 max 或 min）
    function dispatchLimit(selector, currentQty, minQty, maxQty, action, attemptedQty, reason) {
      const lineIndex = selector.getAttribute('data-line');
      const variantId = selector.getAttribute('data-variant-id');
      const detail = {
        lineIndex: parseInt(lineIndex, 10),
        variantId: variantId,
        currentQuantity: currentQty,
        attemptedQuantity: attemptedQty,
        minQuantity: minQty,
        maxQuantity: maxQty,
        action: action,
        reason: reason || '',
        selector: selector
      };

      selector.dispatchEvent(new CustomEvent('quantity:limit', {
        bubbles: true,
        composed: true,
        detail: detail
      }));
      $narwal.emit('quantity:limit', detail);
    }

    // 辅助函数：更新 UI 状态
    function updateUI(selector, newQty, minQty, maxQty) {
      const decreaseBtn = selector.querySelector('[data-action="decrease"]');
      const increaseBtn = selector.querySelector('[data-action="increase"]');
      const input = selector.querySelector('input[data-quantity-input]');

      if (input.value != newQty) {
        input.value = newQty;
      }

      if (decreaseBtn) {
        decreaseBtn.disabled = newQty <= minQty;
      }
      if (increaseBtn) {
        increaseBtn.disabled = newQty >= maxQty;
      }
    }

    // 辅助函数：获取配置信息
    function getSelectorConfig(selector, input) {
      const minAttr = selector.getAttribute('data-min');
      let parsedMin = parseInt(minAttr, 10);
      let minQty = !isNaN(parsedMin) ? parsedMin : 1;

      const maxAttr = selector.getAttribute('data-max');
      let parsedMax = parseInt(maxAttr, 10);
      let maxQty = !isNaN(parsedMax) ? parsedMax : Infinity;

      let currentQty = parseInt(input.value || input.defaultValue, 10);
      if (isNaN(currentQty)) currentQty = minQty;

      return { minQty, maxQty, currentQty };
    }

    // 辅助函数：校验数量并返回合法值
    // 如果校验失败（无效数字）返回 -1
    // 如果校验通过但超出边界，返回修正后的合法值
    function calculateAndValidateQuantity(baseQty, minQty, maxQty, action) {
      let targetQty = baseQty;

      if (action === 'increase') {
        targetQty = baseQty + 1;
      } else if (action === 'decrease') {
        targetQty = baseQty - 1;
      } else if (typeof action === 'number') {
        // 直接传入了目标数量（从输入框读取）
        targetQty = action;
      }

      if (isNaN(targetQty)) return -1;

      if (targetQty > maxQty) targetQty = maxQty;
      if (targetQty < minQty) targetQty = minQty;

      return targetQty;
    }

    // 核心逻辑：修改数量
    function modifyQuantity(selector, action) {
      const input = selector.querySelector('input[data-quantity-input]');
      if (!input || input.disabled) return;

      const { minQty, maxQty, currentQty } = getSelectorConfig(selector, input);

      const newQty = calculateAndValidateQuantity(currentQty, minQty, maxQty, action);

      // 校验失败（无效数字）或数量未变
      if (newQty === -1 || newQty === currentQty) {
        // 达到边界时，给外部一个可用于 a11y/提示的事件
        if (action === 'increase' && maxQty !== Infinity && currentQty >= maxQty) {
          dispatchLimit(selector, currentQty, minQty, maxQty, 'increase', currentQty + 1, 'max');
        } else if (action === 'decrease' && currentQty <= minQty) {
          dispatchLimit(selector, currentQty, minQty, maxQty, 'decrease', currentQty - 1, 'min');
        }
        return;
      }

      updateUI(selector, newQty, minQty, maxQty);
      input.defaultValue = newQty;

      dispatchChange(selector, newQty, currentQty, action);
    }

    // 监听输入框变化 (change 事件在失去焦点或回车时触发)
    document.addEventListener('change', function(e) {
      const input = e.target;
      if (!input.matches('[data-quantity-selector] input[data-quantity-input]')) return;

      const selector = input.closest('[data-quantity-selector]');
      if (!selector) return;

      const { minQty, maxQty } = getSelectorConfig(selector, input);

      // 对于 change 事件，input.value 已经是新值，defaultValue 是旧值
      let oldQty = parseInt(input.defaultValue, 10);
      if (isNaN(oldQty)) oldQty = minQty;

      let inputVal = parseInt(input.value, 10);

      const newQty = calculateAndValidateQuantity(oldQty, minQty, maxQty, inputVal);

      // 校验失败（无效数字），回退到原值
      if (newQty === -1) {
         input.value = oldQty;
         return;
      }

      // 更新 UI 和触发事件
      updateUI(selector, newQty, minQty, maxQty);

      // 总是触发事件，即使数量未变（因为调用方可能依赖这个事件来同步状态）
      // 更新 defaultValue 以备下次使用
      input.defaultValue = newQty;
      dispatchChange(selector, newQty, oldQty, 'input');

      // 如果用户输入超过 max/min，也触发受限事件，供外部提示（a11y）
      if (!isNaN(inputVal)) {
        if (maxQty !== Infinity && inputVal > maxQty) {
          dispatchLimit(selector, newQty, minQty, maxQty, 'input', inputVal, 'max');
        } else if (inputVal < minQty) {
          dispatchLimit(selector, newQty, minQty, maxQty, 'input', inputVal, 'min');
        }
      }
    });

    // 监听键盘事件，支持键盘操作上下按钮
    document.addEventListener('keydown', function(e) {
      // 检查是否聚焦在输入框上
      const input = e.target;
      if (!input.matches('[data-quantity-selector] input[data-quantity-input]')) return;

      const selector = input.closest('[data-quantity-selector]');
      if (!selector) return;

      if (e.key === 'ArrowUp') {
        e.preventDefault();
        modifyQuantity(selector, 'increase');
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        modifyQuantity(selector, 'decrease');
      }
    });

    // 监听按钮点击
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-quantity-selector] .ndev-quantity-selector__btn');
      if (!btn || btn.disabled) return;

      e.preventDefault();
      e.stopPropagation();

      const selector = btn.closest('[data-quantity-selector]');
      const action = btn.getAttribute('data-action');

      modifyQuantity(selector, action);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-scroll-countup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ndev-scroll-countup')) {
    class NdevScrollCountup extends BaseElement {
      static get observedAttributes() {
        return ['active', 'value', 'prefix', 'suffix', 'duration'];
      }

      init() {
        this.numberEl = this.querySelector('.ndev-scroll-countup__number');
        this.prefixEl = this.querySelector('.ndev-scroll-countup__prefix');
        this.suffixEl = this.querySelector('.ndev-scroll-countup__suffix');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.frame = 0;
        this.hasPlayed = false;
        this.updateParts();

        if (this.hasAttribute('active')) {
          this.play();
        } else if (this.hasAttribute('reset-on-exit')) {
          this.renderNumber(0);
        }
      }

      dispose() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue || !this.isConnected) return;

        if (name === 'active') {
          if (this.hasAttribute('active')) {
            this.play();
          } else if (this.hasAttribute('reset-on-exit')) {
            this.reset();
          }
          return;
        }

        this.updateParts();
        if (this.hasAttribute('active')) this.play(true);
      }

      readTarget() {
        const raw = this.getAttribute('value') || '0';
        const value = Number(this.readNumericText(raw));
        return Number.isFinite(value) ? value : 0;
      }

      readDuration() {
        const value = Number(this.getAttribute('duration'));
        return Number.isFinite(value) && value > 0 ? value : 1.2;
      }

      readDecimals() {
        const raw = this.getAttribute('value') || '0';
        const decimal = this.readNumericText(raw).split('.')[1];
        return decimal ? decimal.length : 0;
      }

      readNumericText(raw) {
        const match = String(raw).replace(/,/g, '').match(/-?\d+(?:\.\d+)?/);
        return match ? match[0] : '0';
      }

      formatNumber(value) {
        return value.toFixed(this.readDecimals());
      }

      updateParts() {
        if (this.prefixEl) this.prefixEl.textContent = this.getAttribute('prefix') || '';
        if (this.suffixEl) this.suffixEl.textContent = this.getAttribute('suffix') || '';

        const finalText = this.formatNumber(this.readTarget());
        this.style.setProperty('--ndev-scroll-countup-min-width', finalText.length + 'ch');
        if (this.numberEl && !this.hasAttribute('active')) {
          this.numberEl.textContent = this.hasAttribute('reset-on-exit') ? this.formatNumber(0) : finalText;
        }
      }

      renderNumber(value) {
        if (!this.numberEl) return;
        this.numberEl.textContent = this.formatNumber(value);
      }

      reset() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.hasPlayed = false;
        this.renderNumber(0);
      }

      play(force = false) {
        if (!this.numberEl) return;
        if (this.hasPlayed && !force) return;
        this.hasPlayed = true;

        if (this.frame) cancelAnimationFrame(this.frame);

        const target = this.readTarget();
        if (this.reducedMotion.matches) {
          this.renderNumber(target);
          return;
        }

        const durationMs = this.readDuration() * 1000;
        const startTime = performance.now();

        const tick = (now) => {
          const elapsed = now - startTime;
          const progress = Math.min(elapsed / durationMs, 1);
          const eased = 1 - Math.pow(1 - progress, 4);
          this.renderNumber(target * eased);

          if (progress < 1) {
            this.frame = requestAnimationFrame(tick);
          } else {
            this.frame = 0;
            this.renderNumber(target);
          }
        };

        this.renderNumber(0);
        this.frame = requestAnimationFrame(tick);
      }
    }

    customElements.define('ndev-scroll-countup', NdevScrollCountup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-scroll-fade-bg"] && !Shopify.designMode) return;
  try {
    (() => {
    const GUARD = '__ndevScrollFadeBg';
    const ROOT_ATTR = 'data-ndev-sfb';

    if (!window[GUARD]) {
      window[GUARD] = {
        instances: new WeakMap(),

        // 计算背景透明度
        calculateOpacity(progress, fadeStart, fadeEnd) {
          if (progress < fadeStart) return 0;
          if (progress > fadeEnd) return 1;
          return (progress - fadeStart) / (fadeEnd - fadeStart);
        },

        init(el) {
          const self = this;
          if (this.instances.has(el)) return;

          // 解析配置
          const fadeStart = parseFloat(el.dataset.ndevSfbFadeStart) || 0;
          const fadeEnd = parseFloat(el.dataset.ndevSfbFadeEnd) || 100;

          // 收集子元素
          const items = [];
          const itemEls = el.querySelectorAll('[data-ndev-sfb-item]');
          itemEls.forEach(function(itemEl) {
            items.push({
              el: itemEl,
              varName: itemEl.dataset.ndevSfbVar || '--ndev-sfb-opacity'
            });
          });

          const inst = {
            el: el,
            fadeStart: fadeStart,
            fadeEnd: fadeEnd,
            items: items,
            isActive: false
          };

          this.instances.set(el, inst);

          // 使用 $narwal.progress 监听进度
          $narwal.progress({ selectors: [el] }, function(progress) {
            inst.isActive = progress.enter;
            if (progress.enter) {
              // 计算 section 进度百分比
              const header = document.getElementById('site-header');
              const headerH = header ? header.offsetHeight : 0;
              const winH = window.innerHeight;
              const viewportHeight = winH - headerH;
              const rect = el.getBoundingClientRect();

              // 基于公式：((viewportH - sectionTop) / (sectionH + viewportH)) * 100
              const sectionProgress = Math.max(0, Math.min(100,
                ((viewportHeight - rect.top) / (rect.height + viewportHeight)) * 100
              ));

              const opacity = self.calculateOpacity(sectionProgress, inst.fadeStart, inst.fadeEnd);

              inst.items.forEach(function(item) {
                item.el.style.setProperty(item.varName, Math.max(0, Math.min(1, opacity)));
              });
            }
          });
        },

        destroy(el) {
          this.instances.delete(el);
        }
      };
    }

    const initElements = function() {
      var elements = document.querySelectorAll('[' + ROOT_ATTR + ']');
      elements.forEach(function(el) {
        if (!window[GUARD].instances.has(el)) {
          window[GUARD].init(el);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initElements);
    } else {
      initElements();
    }

    // Shopify 生命周期
    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target;
      var elements = section.querySelectorAll('[' + ROOT_ATTR + ']');
      elements.forEach(function(el) {
        window[GUARD].init(el);
      });
    });

    document.addEventListener('shopify:section:unload', function(event) {
      var section = event.target;
      var elements = section.querySelectorAll('[' + ROOT_ATTR + ']');
      elements.forEach(function(el) {
        window[GUARD].destroy(el);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-scroll-fade-text"] && !Shopify.designMode) return;
  try {
    (() => {
    const GUARD = '__ndevScrollFadeText';
    const ROOT_ATTR = 'data-ndev-sft';

    if (!window[GUARD]) {
      window[GUARD] = {
        instances: new WeakMap(),
        rafId: null,
        pendingUpdates: new Set(),

        // 计算文字透明度
        calculateOpacity(el, config, viewportInfo) {
          const self = this;
          const { isSmallScreen, headerHeight, winH, imageH } = viewportInfo;
          const params = config.params;

          // 获取动态配置值 - 基于屏幕高度选择
          const clipTopPx = isSmallScreen ? params.clipTopMb : params.clipTopPc;
          // 如果 clipBottom 为 0，则使用图片高度作为默认值
          let clipBottomPx = isSmallScreen ? params.clipBottomMb : params.clipBottomPc;
          if (clipBottomPx === 0) clipBottomPx = imageH;

          const fadeTopPct = params.fadeTopPct;
          const fadeBottomPct = params.fadeBottomPct;

          // 简单动画模式：只判断元素是否在可视区域，返回 0 或 1
          if (!config.enableScrollAnim) {
            const rect = el.getBoundingClientRect();
            const elemTop = rect.top;
            const elemBottom = rect.bottom;

            const viewportWindowH = Math.max(0, winH - headerHeight - clipBottomPx);
            const limitClipTop = headerHeight + clipTopPx;
            const limitClipBottom = winH - clipBottomPx;

            // 底部裁剪区：完全隐藏
            if (elemBottom > limitClipBottom) return 0;
            // 顶部裁剪区：根据 isSticky 和 enableFadeOut 判断
            if (elemTop < limitClipTop) {
              return (config.isSticky || !config.enableFadeOut) ? 1 : 0;
            }
            // 在可视区域内：显示
            return 1;
          }

          // 完整动画模式
          const viewportWindowH = Math.max(0, winH - headerHeight - clipBottomPx);
          const limitClipTop = headerHeight + clipTopPx;
          const limitFadeTop = limitClipTop + (viewportWindowH * fadeTopPct / 100);
          const limitClipBottom = winH - clipBottomPx;
          const limitFadeBottom = limitClipBottom - (viewportWindowH * fadeBottomPct / 100);

          const rect = el.getBoundingClientRect();
          const elemTop = rect.top;
          const elemBottom = rect.bottom;

          // E. 底部裁剪区下方
          if (elemBottom > limitClipBottom) return 0;

          // D. 底部过渡区（渐显）
          if (elemBottom > limitFadeBottom) {
            const fadeRange = limitClipBottom - limitFadeBottom;
            if (fadeRange <= 0) return 1;
            return (limitClipBottom - elemBottom) / fadeRange;
          }

          // C. 中间安全区
          if (elemTop > limitFadeTop) return 1;

          // B. 顶部过渡区
          if (elemTop > limitClipTop) {
            if (config.isSticky || !config.enableFadeOut) return 1;
            const fadeRange = limitFadeTop - limitClipTop;
            if (fadeRange <= 0) return 1;
            return (elemTop - limitClipTop) / fadeRange;
          }

          // A. 顶部裁剪区
          return (config.isSticky || !config.enableFadeOut) ? 1 : 0;
        },

        loop() {
          const self = this;
          this.pendingUpdates.forEach(function(el) {
            const inst = self.instances.get(el);
            if (!inst || !inst.isActive) return;

            const header = document.getElementById('site-header');
            const headerH = header ? header.offsetHeight : 0;
            const winH = window.innerHeight;
            const winW = window.innerWidth;
            const isSmallScreen = (winW < 1024) || (winH <= 800);
            const imageH = isSmallScreen ? inst.config.heightMb : inst.config.heightPc;

            const viewportInfo = { isSmallScreen, headerHeight: headerH, winH, imageH };

            inst.items.forEach(function(item) {
              if (!item.el || item.enabled === false) return;
              const op = self.calculateOpacity(item.el, inst.config, viewportInfo);
              item.el.style.setProperty(item.varName, Math.max(0, Math.min(1, op)));
            });
          });

          this.pendingUpdates.clear();
          this.rafId = null;
        },

        schedule(el) {
          this.pendingUpdates.add(el);
          if (!this.rafId) {
            const self = this;
            this.rafId = requestAnimationFrame(function() { self.loop(); });
          }
        },

        init(el) {
          const self = this;
          if (this.instances.has(el)) return;

          // 解析配置
          const config = {
            params: {
              clipTopPc: parseFloat(el.dataset.ndevSftClipTopPc) || 0,
              clipTopMb: parseFloat(el.dataset.ndevSftClipTopMb) || 0,
              fadeTopPct: parseFloat(el.dataset.ndevSftFadeTopPct) || 20,
              clipBottomPc: parseFloat(el.dataset.ndevSftClipBottomPc) || 0,
              clipBottomMb: parseFloat(el.dataset.ndevSftClipBottomMb) || 0,
              fadeBottomPct: parseFloat(el.dataset.ndevSftFadeBottomPct) || 20
            },
            heightPc: parseFloat(el.dataset.ndevSftHeightPc) || 600,
            heightMb: parseFloat(el.dataset.ndevSftHeightMb) || 400,
            isSticky: el.hasAttribute('data-ndev-sft-sticky'),
            enableFadeOut: el.hasAttribute('data-ndev-sft-fade-out'),
            enableScrollAnim: true
          };

          // 检查简单动画模式
          if (el.hasAttribute('data-ndev-sft-simple')) {
            config.enableScrollAnim = false;
          }

          // 收集子元素
          const items = [];
          const itemEls = el.querySelectorAll('[data-ndev-sft-item]');
          itemEls.forEach(function(itemEl) {
            items.push({
              el: itemEl,
              varName: itemEl.dataset.ndevSftVar || '--ndev-sft-opacity',
              enabled: itemEl.dataset.ndevSftEnabled !== 'false'
            });
          });

          const inst = {
            el: el,
            config: config,
            items: items,
            isActive: true
          };

          this.instances.set(el, inst);

          // 监听滚动
          $narwal.on('scroll', function() {
            self.schedule(el);
          });

          // 监听 resize
          $narwal.on('resize', function() {
            self.schedule(el);
          });

          // 初始更新
          this.schedule(el);
        },

        destroy(el) {
          this.instances.delete(el);
          this.pendingUpdates.delete(el);
        }
      };
    }

    const initElements = function() {
      var elements = document.querySelectorAll('[' + ROOT_ATTR + ']');
      elements.forEach(function(el) {
        if (!window[GUARD].instances.has(el)) {
          window[GUARD].init(el);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initElements);
    } else {
      initElements();
    }

    // Shopify 生命周期
    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target;
      var elements = section.querySelectorAll('[' + ROOT_ATTR + ']');
      elements.forEach(function(el) {
        window[GUARD].init(el);
      });
    });

    document.addEventListener('shopify:section:unload', function(event) {
      var section = event.target;
      var elements = section.querySelectorAll('[' + ROOT_ATTR + ']');
      elements.forEach(function(el) {
        window[GUARD].destroy(el);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-scroll-frame"] && !Shopify.designMode) return;
  try {
    (() => {
    const GUARD = '__ndevScrollFrame';
    const ROOT_ATTR = 'data-ndev-sf';

    if (!window[GUARD]) {
      window[GUARD] = {
        instances: new WeakMap(),
        rafId: null,
        pendingFps: new Map(),
        pendingProgress: new Map(),

        loop() {
          const self = this;
          const entries = Array.from(this.pendingFps.entries());
          this.pendingFps.clear();

          entries.forEach(function(entry) {
            const el = entry[0];
            const fps = entry[1];
            const inst = self.instances.get(el);
            if (inst && inst.isActive && inst.render) {
              const progress = Math.max(0, Math.min(1, fps));
              const rendered = inst.render(progress);
              if (rendered !== false && !inst.posterHidden) {
                self.hidePoster(inst);
                inst.posterHidden = true;
                if (!inst.readyEmitted) {
                  inst.readyEmitted = true;
                  el.dispatchEvent(new CustomEvent('ndev-sf-ready', {
                    detail: { duration: inst.duration },
                    bubbles: true
                  }));
                }
              }
              self.emitProgress(el, progress, inst);
            }
          });

          this.rafId = null;
        },

        emitProgress(el, progress, inst) {
          const key = el;
          const lastProgress = this.pendingProgress.get(key) || -1;
          const currentProgress = Math.round(progress * 1000);

          if (currentProgress !== lastProgress) {
            this.pendingProgress.set(key, currentProgress);
            el.dispatchEvent(new CustomEvent('ndev-sf-progress', {
              detail: {
                progress: progress,
                percent: Math.round(progress * 100),
                duration: inst.duration || 0
              },
              bubbles: true
            }));
          }
        },

        schedule(el, fps) {
          this.pendingFps.set(el, fps);
          if (!this.rafId) {
            const self = this;
            this.rafId = requestAnimationFrame(function() { self.loop(); });
          }
        },

        hidePoster(inst) {
          const posters = inst.canvasWrap.querySelectorAll('.ndev-sf__poster');
          posters.forEach(function(p) { p.classList.add('hidden'); });
        },

        init(options) {
          const self = this;
          const el = options.el;
          const pcUrl = options.pcUrl;
          const mbUrl = options.mbUrl;
          const fps = options.fps;
          const canvasWrap = el.querySelector('[data-ndev-sf-canvas]');
          const canvas = canvasWrap ? canvasWrap.querySelector('canvas') : null;
          if (!canvas) return;

          const vhPerSecond = parseFloat(el.dataset.ndevSfVhPerSecond) || 100;
          const pcDuration = parseFloat(canvasWrap.dataset.ndevSfPcDuration) || 0;
          const mbDuration = parseFloat(canvasWrap.dataset.ndevSfMbDuration) || pcDuration;
          const frameInterval = parseInt(canvasWrap.dataset.ndevSfFrameInterval, 10) || 40;

          const duration = $narwal.isMobile ? mbDuration : pcDuration;
          const heightVh = Math.ceil(duration * vhPerSecond);
          el.style.height = heightVh + 'vh';

          const inst = {
            el: el,
            canvas: canvas,
            canvasWrap: canvasWrap,
            ctx: canvas.getContext('2d'),
            fps: fps,
            frameInterval: frameInterval,
            render: null,
            isActive: false,
            posterHidden: false,
            duration: duration,
            readyEmitted: false
          };

          this.instances.set(el, inst);

          const url = $narwal.isMobile ? (mbUrl || pcUrl) : pcUrl;
          if (url) {
            $narwal.load('fps', function(videoFps) {
              inst.render = videoFps.initVideo({
                el: inst.el,
                canvas: inst.canvas,
                ctx: inst.ctx,
                url: url,
                mobileUrl: mbUrl,
                desktopUrl: pcUrl,
                frameInterval: frameInterval
              });
            });
          }

          // 启动滚动监听
          $narwal.progress({ selectors: [el] }, function(progress) {
            inst.isActive = progress.enter;
            if (progress.enter) {
              self.schedule(el, progress.visualFps);
            }
          });
        }
      };
    }

    const initElements = function() {
      var elements = document.querySelectorAll('[' + ROOT_ATTR + ']');
      elements.forEach(function(el) {
        if (!window[GUARD].instances.has(el)) {
          var wrap = el.querySelector('[data-ndev-sf-canvas]');
          if (wrap) {
            window[GUARD].init({
              el: el,
              pcUrl: wrap.dataset.ndevSfPcUrl || '',
              mbUrl: wrap.dataset.ndevSfMbUrl || '',
              fps: parseInt(wrap.dataset.ndevSfFps, 10) || 30
            });
          }
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initElements);
    } else {
      initElements();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-share-social-media-list"] && !Shopify.designMode) return;
  try {
    (function() {
    // 检测触摸屏设备和减少动画偏好
    var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
    var motionReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // 在触摸屏或减少动画模式下跳过特效
    if (isTouch || motionReduced) return;

    // 为所有分享按钮添加 data-ndev-magnet 属性（默认磁吸强度 10）
    var buttons = document.querySelectorAll('.ndev-share-list .share-item');

    buttons.forEach(function(btn) {
      // 跳过已初始化的按钮
      if (btn.hasAttribute('data-ndev-magnet-initialized')) return;

      btn.setAttribute('data-ndev-magnet', btn.getAttribute('data-ndev-magnet') || '10');
      btn.setAttribute('data-ndev-magnet-initialized', 'true');

      btn.addEventListener('mousemove', function(e) {
        var magnet = parseInt(this.getAttribute('data-ndev-magnet')) || 10;
        if (magnet === 0) return;

        var rect = this.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width - 0.5) * magnet;
        var y = ((e.clientY - rect.top) / rect.height - 0.5) * magnet;

        this.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
        this.style.transition = 'transform 0.15s ease-out';
      });

      btn.addEventListener('mouseleave', function() {
        this.style.transform = 'translate(0, 0)';
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-social-media-share-icon"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  if (!window.ComponentRegistry) return;

  var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
  var motionReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onMouseMove(e) {
    var root = e.currentTarget;
    var magnet = parseInt(root.getAttribute('data-magnet')) || 10;
    var rect = root.getBoundingClientRect();
    var x = ((e.clientX - rect.left) / rect.width - 0.5) * magnet;
    var y = ((e.clientY - rect.top) / rect.height - 0.5) * magnet;
    root.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
  }

  function onMouseLeave(e) {
    e.currentTarget.style.transform = 'translate(0, 0)';
  }

  function init(root) {
    if (!root) return;
    if (isTouch || motionReduced) return;

    var magnet = parseInt(root.getAttribute('data-magnet')) || 10;
    if (magnet === 0) return;

    root.addEventListener('mousemove', onMouseMove);
    root.addEventListener('mouseleave', onMouseLeave);
  }

  function dispose(root) {
    if (!root) return;
    root.removeEventListener('mousemove', onMouseMove);
    root.removeEventListener('mouseleave', onMouseLeave);
    root.style.transform = '';
  }

  ComponentRegistry.register({
    ns: 'ndev-share-icon',
    mode: 'component',
    selector: '.ndev-share-icon[data-magnet]:not([data-magnet="0"])',
    init: init,
    dispose: dispose
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-standard-installment-affirm"] && !Shopify.designMode) return;
  try {
    if (!window.__ndevInstallmentAffirmUpdateBound) {
    window.__ndevInstallmentAffirmUpdateBound = true;

    document.addEventListener('ndev-standard-installment:update:affirm', (event) => {
      const scope = event.target;
      if (!(scope instanceof Element)) return;

      const price = Number(event.detail && event.detail.price);
      if (!Number.isFinite(price) || price <= 0) return;

      const pendings = scope.querySelectorAll('.affirm-as-low-as');
      if (!pendings.length) return;

      pendings.forEach((pending) => {
        pending.setAttribute('data-amount', String(price));
      });

      if (window.affirm?.ui) window.affirm.ui.refresh();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-standard-installment-group"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ndev-standard-installment-group')) {
    class NdevStandardInstallmentGroup extends BaseElement {
      init() {
        this._onPriceChange = (event) => this._handlePriceChange(event);
        document.addEventListener('ndev-standard-installment:price-change', this._onPriceChange);
      }

      dispose() {
        document.removeEventListener('ndev-standard-installment:price-change', this._onPriceChange);
      }

      _handlePriceChange(event) {
        const scope = event.target;
        if (!(scope instanceof Element) || !scope.contains(this)) return;

        const price = Number(event.detail && event.detail.price);
        if (!Number.isFinite(price) || price <= 0) return;

        this._dispatchProviderUpdate('klarna', price);
        this._dispatchProviderUpdate('paypal', price);
        this._dispatchProviderUpdate('affirm', price);
      }

      /* 各渠道的更新处理由对应 snippet 自己监听，这里只按渠道转发 */
      _dispatchProviderUpdate(provider, price) {
        this.dispatchEvent(new CustomEvent(`ndev-standard-installment:update:${provider}`, {
          bubbles: true,
          detail: { price: price }
        }));
      }
    }
    customElements.define('ndev-standard-installment-group', NdevStandardInstallmentGroup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-standard-installment-klarna"] && !Shopify.designMode) return;
  try {
    if (!window.__ndevInstallmentKlarnaUpdateBound) {
    window.__ndevInstallmentKlarnaUpdateBound = true;

    document.addEventListener('ndev-standard-installment:update:klarna', (event) => {
      const scope = event.target;
      if (!(scope instanceof Element)) return;

      const price = Number(event.detail && event.detail.price);
      if (!Number.isFinite(price) || price <= 0) return;

      const placements = scope.querySelectorAll('klarna-placement');
      if (!placements.length) return;

      placements.forEach((placement) => {
        placement.setAttribute('data-purchase-amount', String(price));
      });

      window.KlarnaOnsiteService?.push({ eventName: 'refresh-placements' });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-standard-installment-paypal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ndev-paypal-message')) {
    class NdevPaypalMessage extends BaseElement {
      init() {
        this._timer = null;
        this._onUpdate = (event) => this._handleUpdate(event);
        document.addEventListener('ndev-standard-installment:update:paypal', this._onUpdate);
        this._render(0);
      }

      dispose() {
        document.removeEventListener('ndev-standard-installment:update:paypal', this._onUpdate);
        this._stopRetry();
      }

      update(amount) {
        this.setAttribute('data-amount', String(amount));
        this._render(0);
      }

      _handleUpdate(event) {
        const scope = event.target;
        if (!(scope instanceof Element) || !scope.contains(this)) return;

        const price = Number(event.detail && event.detail.price);
        if (!Number.isFinite(price) || price <= 0) return;

        this.update(price);
      }

      _render(tries) {
        this._stopRetry();

        const sdk = window.PayPalSDK;
        if (!sdk || typeof sdk.Messages !== 'function') {
          if (tries < 40) {
            this._timer = window.setTimeout(() => this._render(tries + 1), 300);
          }
          return;
        }

        const amountCents = Number(this.getAttribute('data-amount'));
        if (!Number.isFinite(amountCents) || amountCents <= 0) {
          this.innerHTML = '';
          this._renderedAmount = null;
          return;
        }

        /* 编辑器 HMR 会对同一实例重跑 init；金额未变时保留已渲染的消息，不重建 */
        if (this._renderedAmount === amountCents) return;

        this.innerHTML = '';
        sdk.Messages({
          amount: amountCents / 100,
          placement: 'product',
          buyerCountry: this.getAttribute('data-buyer-country') || ''
        }).render(this);
        this._renderedAmount = amountCents;
      }

      _stopRetry() {
        if (!this._timer) return;
        window.clearTimeout(this._timer);
        this._timer = null;
      }
    }
    customElements.define('ndev-paypal-message', NdevPaypalMessage);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-standard-select"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    if (window.__ndevStandardSelect__) return;

    function toBool(val, defaultValue) {
      if (val === 'true') return true;
      if (val === 'false') return false;
      return defaultValue;
    }

    function closeRoot(root) {
      if (!root) return;
      if (root.dataset.ndevSelectOpen !== '1') return;

      if (root.__ndevSelectClose) {
        root.__ndevSelectClose();
        return;
      }

      var trigger = root.querySelector('.ndev-standard-select__trigger');
      var dropdown = root.querySelector('.ndev-standard-select__dropdown');
      if (!trigger || !dropdown) return;

      dropdown.classList.remove('is-open');
      trigger.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      root.dataset.ndevSelectOpen = '0';

      dropdown.style.left = '';
      dropdown.style.top = '';
      dropdown.style.bottom = '';
      dropdown.style.width = '';
      dropdown.style.maxHeight = '';

      if (root.__ndevSelectScrollHandler) {
        window.removeEventListener('scroll', root.__ndevSelectScrollHandler, true);
        window.removeEventListener('resize', root.__ndevSelectScrollHandler);
        root.__ndevSelectScrollHandler = null;
      }

      var focused = root.querySelectorAll('.ndev-standard-select__option.is-focused');
      focused.forEach(function (el) {
        el.classList.remove('is-focused');
      });
    }

    function initRoot(root) {
      if (!root || root.dataset.ndevSelectBound === '1') return;
      root.dataset.ndevSelectBound = '1';

      var trigger = root.querySelector('.ndev-standard-select__trigger');
      var dropdown = root.querySelector('.ndev-standard-select__dropdown');
      var triggerText = root.querySelector('.ndev-standard-select__trigger-text');
      var hiddenInput = root.querySelector('.ndev-standard-select__hidden-input');
      if (!trigger || !dropdown || !triggerText || !hiddenInput) return;

      var external = root.getAttribute('data-external-state') === 'true';
      var bundleAppearance = root.classList.contains('ndev-standard-select--bundle');
      var keyboardFocus = false;
      if (!external && (trigger.classList.contains('is-disabled') || root.classList.contains('ndev-standard-select--disabled'))) return;
      var priceText = root.querySelector('.ndev-standard-select__price');
      var portal = null;
      var listeners = [];
      function listen(el, type, fn) { el.addEventListener(type, fn); listeners.push(function () { el.removeEventListener(type, fn); }); }
      function disabled() { return trigger.classList.contains('is-disabled'); }
      function optionDisabled(opt) { return opt.getAttribute('aria-disabled') === 'true'; }

      var options = Array.prototype.slice.call(root.querySelectorAll('.ndev-standard-select__option'));
      var enableKeyboard = toBool(root.getAttribute('data-enable-keyboard'), false);
      if (external) options.forEach(function (opt, i) { opt.id = root.getAttribute('data-select-scope') + '-option-' + i; });

      var isOpen = false;
      var focusedIndex = -1;
      var previousValue = hiddenInput.value || '';

      var selectedOption = root.querySelector('.ndev-standard-select__option.is-selected');
      if (selectedOption) {
        var label = selectedOption.getAttribute('data-label') || '';
        if (label) {
          triggerText.textContent = label;
          triggerText.classList.remove('is-placeholder');
          if (priceText) priceText.textContent = selectedOption.getAttribute('data-price') || '';
        }
      }

      function removeFocusedClass() {
        options.forEach(function (opt) {
          opt.classList.remove('is-focused');
          if (bundleAppearance) opt.classList.remove('is-keyboard-focused');
        });
      }

      function setKeyboardFocus(on) {
        if (!bundleAppearance) return;
        keyboardFocus = on;
        options.forEach(function (opt) { opt.classList.toggle('is-keyboard-focused', on && opt.classList.contains('is-focused')); });
      }
      if (bundleAppearance) {
        listen(trigger, 'pointerdown', function () { setKeyboardFocus(false); });
        listen(dropdown, 'pointermove', function () { setKeyboardFocus(false); });
      }

      /** 只在下拉面板内滚动，避免 scrollIntoView 带动 Swiper 等外层滚动导致反复 position 与闪烁 */
      function scrollOptionIntoDropdownPanel(optionEl) {
        if (!optionEl || !dropdown) return;
        var dRect = dropdown.getBoundingClientRect();
        var oRect = optionEl.getBoundingClientRect();
        if (oRect.top < dRect.top) {
          dropdown.scrollTop -= dRect.top - oRect.top;
        } else if (oRect.bottom > dRect.bottom) {
          dropdown.scrollTop += oRect.bottom - dRect.bottom;
        }
      }

      function setFocusedOption(index) {
        removeFocusedClass();
        if (index >= 0 && index < options.length && !optionDisabled(options[index])) {
          focusedIndex = index;
          options[index].classList.add('is-focused');
          if (bundleAppearance && keyboardFocus) options[index].classList.add('is-keyboard-focused');
          if (external) trigger.setAttribute('aria-activedescendant', options[index].id);
          scrollOptionIntoDropdownPanel(options[index]);
        }
      }

      /**
       * 当任意祖先存在 transform / filter / perspective 时，fixed 的定位包含块不再是视口，
       * 而是该祖先（例如 Swiper 的 .swiper-wrapper）。此时仍使用视口坐标设置 top/left 会整体错位。
       */
      function getFixedContainingBlock(el) {
        var node = el.parentElement;
        while (node && node !== document.documentElement && node !== document.body) {
          var st = window.getComputedStyle(node);
          var tf = st.transform;
          var filt = st.filter;
          var persp = st.perspective;
          var bf = st.backdropFilter || st.webkitBackdropFilter;
          if (
            (tf && tf !== 'none') ||
            (filt && filt !== 'none') ||
            (persp && persp !== 'none') ||
            (bf && bf !== 'none')
          ) {
            return node;
          }
          node = node.parentElement;
        }
        return null;
      }

      function positionDropdown() {
        var rect = trigger.getBoundingClientRect();
        var gap = 4;
        var cb = portal ? null : getFixedContainingBlock(trigger);
        var cbRect = cb ? cb.getBoundingClientRect() : null;

        dropdown.style.left = (rect.left - (cbRect ? cbRect.left : 0)) + 'px';
        dropdown.style.width = rect.width + 'px';

        dropdown.style.top = '';
        dropdown.style.bottom = '';
        dropdown.style.maxHeight = '';

        var spaceBelow = window.innerHeight - rect.bottom - gap;
        var spaceAbove = rect.top - gap;

        if (spaceBelow >= 120 || spaceBelow >= spaceAbove) {
          dropdown.setAttribute('data-placement', 'bottom');
          if (cbRect) {
            dropdown.style.top = rect.bottom - cbRect.top + gap + 'px';
          } else {
            dropdown.style.top = rect.bottom + gap + 'px';
          }
          if (spaceBelow < 240) {
            dropdown.style.maxHeight = Math.max(spaceBelow, 80) + 'px';
          }
        } else {
          dropdown.setAttribute('data-placement', 'top');
          if (cbRect) {
            dropdown.style.bottom = cbRect.bottom - rect.top + gap + 'px';
          } else {
            dropdown.style.bottom = window.innerHeight - rect.top + gap + 'px';
          }
          if (spaceAbove < 240) {
            dropdown.style.maxHeight = Math.max(spaceAbove, 80) + 'px';
          }
        }
      }

      var positionDropdownRaf = null;
      function onScrollOrResize() {
        if (!isOpen) return;
        if (positionDropdownRaf != null) return;
        positionDropdownRaf = requestAnimationFrame(function () {
          positionDropdownRaf = null;
          if (isOpen) positionDropdown();
        });
      }

      root.__ndevSelectScrollHandler = onScrollOrResize;

      function setOpen(nextOpen) {
        if (nextOpen && disabled()) return;
        isOpen = nextOpen;
        root.dataset.ndevSelectOpen = isOpen ? '1' : '0';

        if (isOpen) {
          document.querySelectorAll('[data-ndev-select-root][data-ndev-select-open="1"]').forEach(function (other) { if (other !== root) closeRoot(other); });
          if (external && !portal) {
            portal = document.createElement('div');
            portal.className = root.className + ' ndev-standard-select--portal';
            portal.setAttribute('style', root.getAttribute('style') || '');
            portal.appendChild(dropdown);
            document.body.appendChild(portal);
            root.__ndevSelectPortal = portal;
          }
          positionDropdown();
          dropdown.classList.add('is-open');
          trigger.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');

          window.addEventListener('scroll', onScrollOrResize, true);
          window.addEventListener('resize', onScrollOrResize);

          var selected = options.find(function (opt) { return opt.classList.contains('is-selected') && !optionDisabled(opt); });
          if (selected) {
            focusedIndex = options.indexOf(selected);
            setFocusedOption(focusedIndex);
          }
        } else {
          if (positionDropdownRaf != null) {
            cancelAnimationFrame(positionDropdownRaf);
            positionDropdownRaf = null;
          }

          dropdown.classList.remove('is-open');
          trigger.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          focusedIndex = -1;
          trigger.removeAttribute('aria-activedescendant');
          removeFocusedClass();
          keyboardFocus = false;
          if (portal) { root.appendChild(dropdown); portal.remove(); portal = null; root.__ndevSelectPortal = null; }

          dropdown.style.left = '';
          dropdown.style.top = '';
          dropdown.style.bottom = '';
          dropdown.style.width = '';
          dropdown.style.maxHeight = '';

          window.removeEventListener('scroll', onScrollOrResize, true);
          window.removeEventListener('resize', onScrollOrResize);
        }
      }

      function toggleDropdown(force) {
        if (typeof force === 'boolean') {
          setOpen(force);
          return;
        }
        setOpen(!isOpen);
      }

      function emitChange(value, text) {
        var changeData = {
          value: value,
          text: text,
          element: root,
          previousValue: previousValue,
          scope: root.getAttribute('data-select-scope') || ''
        };

        var shouldEmitEvent = trigger.getAttribute('data-emit-event') === 'true';
        if (shouldEmitEvent) {
          var eventName = trigger.getAttribute('data-event-name') || 'ndev-select:change';
          document.dispatchEvent(
            new CustomEvent(eventName, {
              detail: changeData,
              bubbles: true,
              cancelable: true
            })
          );
        }

        var ga4ReportRaw = trigger.getAttribute('data-ga4-report');
        if (ga4ReportRaw && window.$narwal && typeof window.$narwal.report === 'function') {
          try {
            var reportData =
              window.$narwal.getJSON && typeof window.$narwal.getJSON === 'function'
                ? window.$narwal.getJSON(ga4ReportRaw.replace(/(\w)'(\w)/g, "$1\\'$2"))
                : Function('return (' + ga4ReportRaw + ')')();

            if (reportData && reportData.params) {
              reportData.params.selected_value = value;
              reportData.params.selected_text = text;
              reportData.params.btn = text;
            }

            if (reportData && reportData.event) {
              window.$narwal.report(reportData.event, reportData.params);
            }
          } catch (err) {
            // no-op: tracking should never break UI
          }
        }

        previousValue = value;
      }

      function selectOption(optionElement, config) {
        if (!optionElement || disabled() || optionDisabled(optionElement)) return false;
        config = config || { emit: true, focus: true };
        var value = optionElement.getAttribute('data-value') || '';
        var label = optionElement.getAttribute('data-label') || '';

        triggerText.textContent = label || '';
        triggerText.classList.remove('is-placeholder');
        if (priceText) priceText.textContent = optionElement.getAttribute('data-price') || '';

        options.forEach(function (opt) {
          opt.classList.remove('is-selected');
          if (external) opt.setAttribute('aria-selected', 'false');
        });
        optionElement.classList.add('is-selected');
        if (external) optionElement.setAttribute('aria-selected', 'true');

        hiddenInput.value = value;
        if (config.emit !== false) emitChange(value, label);
        else previousValue = value;

        toggleDropdown(false);
        if (config.focus !== false) trigger.focus();
        return true;
      }

      root.__ndevSelectClose = function () {
        setOpen(false);
      };

      listen(trigger, 'click', function (e) {
        if (bundleAppearance && window.Shopify && Shopify.inspectMode) return;
        if (disabled()) return;
        e.stopPropagation();
        if (!isOpen) {
          document.querySelectorAll('[data-ndev-select-root][data-ndev-select-open="1"]').forEach(function (other) {
            if (other !== root && other.__ndevSelectClose) {
              other.__ndevSelectClose();
            }
          });
        }
        toggleDropdown();
      });

      options.forEach(function (option) {
        listen(option, 'click', function (e) {
          e.stopPropagation();
          selectOption(option);
        });
      });

      function nextEnabled(start, step) {
        for (var i = start; i >= 0 && i < options.length; i += step) if (!optionDisabled(options[i])) return i;
        return focusedIndex;
      }
      var search = '', searchAt = 0;
      if (enableKeyboard) {
        listen(trigger, 'keydown', function (e) {
          if (disabled()) return;
          if (e.key === 'Tab') { setOpen(false); return; }
          if (e.key === 'Escape') {
            if (toBool(root.getAttribute('data-enable-esc-close'), true)) { setOpen(false); e.preventDefault(); }
            return;
          }
          if (['Enter', ' ', 'ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(e.key) >= 0) {
            setKeyboardFocus(true);
            e.preventDefault();
            if (e.key === 'Enter' || e.key === ' ') {
              if (isOpen && focusedIndex >= 0) selectOption(options[focusedIndex]);
              else { setOpen(true); if (focusedIndex < 0) setFocusedOption(nextEnabled(0, 1)); }
            } else {
              var wasOpen = isOpen;
              if (!isOpen) setOpen(true);
              if (e.key === 'Home') setFocusedOption(nextEnabled(0, 1));
              else if (e.key === 'End') setFocusedOption(nextEnabled(options.length - 1, -1));
              else if (wasOpen || focusedIndex < 0) setFocusedOption(nextEnabled(e.key === 'ArrowDown' ? focusedIndex + 1 : (focusedIndex < 0 ? options.length - 1 : focusedIndex - 1), e.key === 'ArrowDown' ? 1 : -1));
            }
          } else if (external && e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
            setKeyboardFocus(true);
            e.preventDefault();
            var now = Date.now(); search = now - searchAt > 700 ? e.key : search + e.key; searchAt = now;
            if (!isOpen) setOpen(true);
            var match = options.findIndex(function (opt) { return !optionDisabled(opt) && (opt.getAttribute('data-label') || '').toLowerCase().indexOf(search.toLowerCase()) === 0; });
            if (match >= 0) setFocusedOption(match);
          }
        });
      }
      if (external) root.ndevSelect = {
        setValue: function (value, config) {
          return selectOption(options.find(function (opt) { return opt.getAttribute('data-value') === String(value); }), { emit: !!(config && config.emit), focus: false });
        },
        setDisabled: function (off) {
          trigger.classList.toggle('is-disabled', !!off);
          root.classList.toggle('ndev-standard-select--disabled', !!off);
          trigger.setAttribute('aria-disabled', String(!!off)); trigger.tabIndex = off ? -1 : 0;
          if (off) setOpen(false);
        },
        setOptionDisabled: function (value, off, reason) {
          var opt = options.find(function (item) { return item.getAttribute('data-value') === String(value); });
          if (opt) {
            opt.setAttribute('aria-disabled', String(!!off));
            if (typeof reason === 'string') opt.textContent = opt.getAttribute('data-label') + (off && reason ? ' (' + reason + ')' : '');
          }
          if (opt && off && options[focusedIndex] === opt) { focusedIndex = -1; removeFocusedClass(); trigger.removeAttribute('aria-activedescendant'); }
        },
        destroy: function () {
          setOpen(false); listeners.forEach(function (remove) { remove(); }); listeners = [];
          delete root.dataset.ndevSelectBound; delete root.ndevSelect; delete root.__ndevSelectClose; delete root.__ndevSelectScrollHandler;
        }
      };
    }

    function scan(ctx) {
      var scope = ctx && ctx.querySelectorAll ? ctx : document;
      if (scope.matches && scope.matches('[data-ndev-select-root]')) initRoot(scope);
      scope.querySelectorAll('[data-ndev-select-root]').forEach(function (root) {
        initRoot(root);
      });
    }

    document.addEventListener('click', function (e) {
      document.querySelectorAll('[data-ndev-select-root][data-ndev-select-open="1"]').forEach(function (root) {
        var enableClickOutside = toBool(root.getAttribute('data-enable-click-outside'), true);
        if (!enableClickOutside) return;
        if (!root.contains(e.target) && !(root.__ndevSelectPortal && root.__ndevSelectPortal.contains(e.target))) closeRoot(root);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-ndev-select-root][data-ndev-select-open="1"]').forEach(function (root) {
        var enableEscClose = toBool(root.getAttribute('data-enable-esc-close'), true);
        if (!enableEscClose) return;
        closeRoot(root);
      });
    });

    document.addEventListener('shopify:section:load', function (e) {
      scan(e.target);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('[data-ndev-select-root]').forEach(function (root) { if (root.ndevSelect) root.ndevSelect.destroy(); });
    });
    scan(document);
    window.__ndevStandardSelect__ = { scan: scan };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-sticky-anchor-navbar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ndev-sticky-anchor-navbar')) {
    const NdevStickyAnchorNavbarBase = window.BaseElement || HTMLElement;

    class NdevStickyAnchorNavbar extends NdevStickyAnchorNavbarBase {
      connectedCallback() {
        if (super.connectedCallback) super.connectedCallback();
        if (!window.BaseElement) this.init();
      }

      disconnectedCallback() {
        if (super.disconnectedCallback) super.disconnectedCallback();
        if (!window.BaseElement) this.dispose();
      }

      init() {
        if (this._initialized) return;
        if (this.getAttribute('enabled') !== 'true') return;
        this._initialized = true;

        this._itemsWrap = this.querySelector('[data-ndev-sticky-anchor-navbar-items]');
        this._bar = this.querySelector('.ndev-sticky-anchor-navbar__bar');
        this._triggerSelector = this.getAttribute('trigger-selector') || 'product-buy-box';
        this._root = this.closest(this._triggerSelector) || this.closest('product-buy-box');
        this._visible = false;
        this._ticking = false;
        this._activeTarget = null;
        this._clickLock = false;
        this._clickLockTimer = null;

        this._onClick = (event) => this._handleClick(event);
        this._onScroll = () => this._scheduleSync();
        this._onResize = () => this._scheduleSync();

        this._items = this._getItems();

        if (!this._items.length) {
          this.hidden = true;
          return;
        }

        this.addEventListener('click', this._onClick);
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onResize, { passive: true });

        this._scheduleSync();
      }

      dispose() {
        if (!this._initialized) return;
        this._initialized = false;
        this.removeEventListener('click', this._onClick);
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onResize);
        if (this._clickLockTimer) clearTimeout(this._clickLockTimer);
      }

      _getItems() {
        return Array.prototype.slice.call(this.querySelectorAll('[data-ndev-sticky-anchor-navbar-item]'));
      }

      _getHeaderOffset() {
        const sources = [this, document.querySelector('#main-content'), document.documentElement];
        for (let i = 0; i < sources.length; i++) {
          const source = sources[i];
          if (!source) continue;
          const raw = window.getComputedStyle(source).getPropertyValue('--header-height').trim();
          const value = parseFloat(raw);
          if (Number.isFinite(value)) return Math.max(0, Math.round(value));
        }
        return 0;
      }

      _getBarHeight() {
        return this._bar ? Math.round(this._bar.getBoundingClientRect().height || 0) : 0;
      }

      _getTriggerTop() {
        if (this._root && document.body.contains(this._root)) {
          return window.scrollY + this._root.getBoundingClientRect().top;
        }

        const trigger = this._triggerSelector ? document.querySelector(this._triggerSelector) : null;
        if (trigger) return window.scrollY + trigger.getBoundingClientRect().top;

        const legacyTop = document.querySelector('.product-top');
        if (legacyTop) return window.scrollY + legacyTop.getBoundingClientRect().top;

        return 1;
      }

      _scheduleSync() {
        if (this._ticking) return;
        this._ticking = true;
        window.requestAnimationFrame(() => {
          this._ticking = false;
          this._sync();
        });
      }

      _sync() {
        if (!this._items || !this._items.length) return;

        const headerOffset = this._getHeaderOffset();

        const showNav = window.scrollY >= this._getTriggerTop();
        this.classList.toggle('is-hidden', !showNav);
        this._emitVisibilityChange(showNav);

        if (!this._clickLock) this._syncActiveByScroll(headerOffset);
      }

      _emitVisibilityChange(visible) {
        if (this._visible === visible) return;
        this._visible = visible;
        this.dispatchEvent(new CustomEvent('ndev-sticky-anchor-navbar:visibility-change', {
          bubbles: true,
          composed: true,
          detail: { visible }
        }));
      }

      _handleClick(event) {
        const item = event.target && event.target.closest
          ? event.target.closest('[data-ndev-sticky-anchor-navbar-item]')
          : null;
        if (!item || !this.contains(item)) return;

        const targetId = item.getAttribute('data-target');
        const target = targetId ? document.getElementById(targetId) : null;
        if (!target) return;

        event.preventDefault();
        this._setActive(item);

        const offset = this._getHeaderOffset() + this._getBarHeight() + 8;
        const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
        const reduced = Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        window.scrollTo({ top, behavior: reduced ? 'auto' : 'smooth' });

        this._clickLock = true;
        if (this._clickLockTimer) clearTimeout(this._clickLockTimer);
        this._clickLockTimer = setTimeout(() => {
          this._clickLock = false;
          this._scheduleSync();
        }, 700);
      }

      _syncActiveByScroll(headerOffset) {
        let matched = null;
        const marker = headerOffset + this._getBarHeight() + 250;

        this._items.forEach((item) => {
          const targetId = item.getAttribute('data-target');
          const target = targetId ? document.getElementById(targetId) : null;
          if (!target) return;
          if (target.getBoundingClientRect().top <= marker) matched = item;
        });

        if (!matched) matched = this._items[0];
        this._setActive(matched);
      }

      _setActive(item) {
        if (!item || this._activeTarget === item.getAttribute('data-target')) return;

        this._items.forEach((entry) => {
          entry.classList.remove('is-active');
          entry.removeAttribute('aria-current');
        });

        item.classList.add('is-active');
        item.setAttribute('aria-current', 'true');
        this._activeTarget = item.getAttribute('data-target');
        this._centerItem(item);
      }

      _centerItem(item) {
        const container = this._bar;
        if (!container || container.scrollWidth <= container.clientWidth + 1) return;

        const itemRect = item.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const center = itemRect.left - containerRect.left + itemRect.width / 2;
        const left = Math.max(0, center - container.clientWidth / 2);
        const reduced = Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        container.scrollTo({ left, behavior: reduced ? 'auto' : 'smooth' });
      }
    }

    customElements.define('ndev-sticky-anchor-navbar', NdevStickyAnchorNavbar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-sticky-prev-cover"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_SELECTOR = '[data-ndev-spc]';
    const PADDING_BOTTOM_ATTR = 'data-ndev-spc-pad';
    const INIT_ATTR = 'data-ndev-spc-init';
    const PREV_CLASS = 'ndev-sticky-prev-cover-prev--sticky';
    const SELF_CLASS = 'ndev-sticky-prev-cover-self--stack';
    const GUARD = '__ndevStickyPrevCover';

    if (!window[GUARD]) {
      window[GUARD] = { instances: new WeakMap() };
    }
    const { instances } = window[GUARD];

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;

      const selfWrap = root.closest('.shopify-section');
      if (!selfWrap) return;

      const prevWrap = selfWrap.previousElementSibling;
      if (!prevWrap || !(prevWrap instanceof HTMLElement)) return;

      const padRaw = root.getAttribute(PADDING_BOTTOM_ATTR);
      const paddingBottom =
        padRaw && String(padRaw).trim() !== '' ? String(padRaw).trim() : '50vh';
      prevWrap.style.paddingBottom = paddingBottom;

      function updateStickyTop() {
        const vh = window.innerHeight;
        const padPx = parseFloat(getComputedStyle(prevWrap).paddingBottom) || 0;
        const hFull = prevWrap.offsetHeight;
        const baseTopPx = vh - (hFull - padPx);
        prevWrap.style.top = `calc(${baseTopPx}px - ${paddingBottom})`;
      }

      prevWrap.classList.add(PREV_CLASS);
      selfWrap.classList.add(SELF_CLASS);
      updateStickyTop();

      window.addEventListener('resize', updateStickyTop, { passive: true });

      let ro;
      if (typeof ResizeObserver !== 'undefined') {
        ro = new ResizeObserver(() => updateStickyTop());
        ro.observe(prevWrap);
      }

      root.setAttribute(INIT_ATTR, '1');
      instances.set(root, () => {
        window.removeEventListener('resize', updateStickyTop);
        if (ro) ro.disconnect();
        prevWrap.classList.remove(PREV_CLASS);
        prevWrap.style.top = '';
        prevWrap.style.paddingBottom = '';
        selfWrap.classList.remove(SELF_CLASS);
        root.removeAttribute(INIT_ATTR);
      });
    }

    function destroyOne(root) {
      const teardown = instances.get(root);
      if (!teardown) return;
      teardown();
      instances.delete(root);
    }

    function initAll(container) {
      (container || document).querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    if (!window[GUARD].listenersBound) {
      window[GUARD].listenersBound = true;
      document.addEventListener('DOMContentLoaded', () => initAll());
      document.addEventListener('shopify:section:load', (event) => initAll(event.target));
      document.addEventListener('shopify:section:unload', (event) => {
        event.target.querySelectorAll(ROOT_SELECTOR).forEach(destroyOne);
      });
    }

    if (document.readyState !== 'loading') {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-tooltip"] && !Shopify.designMode) return;
  try {
    class NdevTooltip extends BaseElement {
    init() {
      this.trigger = this.querySelector('.ndev-tooltip__trigger');
      this.panel = this.querySelector('[data-ndev-tooltip-panel]');
      this.supportsInterest = Object.hasOwn(HTMLButtonElement.prototype, 'interestForElement');
      this.openTimer = null;
      this.closeTimer = null;
      this.openedAt = 0;
      this.openedByInterest = false;

      this.onInterest = (event) => {
        if (event.target !== this.panel) return;
        this.markOpened('interest');
        window.requestAnimationFrame(() => this.setPlacement());
      };
      this.onDocumentPointerDown = (event) => {
        if (this.contains(event.target)) return;
        this.hide();
      };
      this.onKeyDown = (event) => {
        if (event.key !== 'Escape') return;
        this.hide();
      };
      // 点击/轻触在所有设备都可开合（等同 modal 的点击展示/隐藏）：
      // 触摸端没有 hover，大屏平板（>1024px）同样无法 hover，而 interestfor 只覆盖 hover/focus/长按
      this.onClick = (event) => this.handleClick(event);

      // interest 事件不冒泡，但捕获阶段可在祖先（本自定义元素）收到
      this.addEventListener('interest', this.onInterest, true);
      this.addEventListener('click', this.onClick);

      // 原生路径的 hover/focus 由浏览器负责；兜底路径由脚本补齐
      if (!this.supportsInterest) {
        this.onPointerOver = (event) => {
          if (event.pointerType === 'touch') return;
          if (!this.contains(event.target)) return;
          this.clearTimers();
          this.openTimer = window.setTimeout(() => this.show(), 200);
        };
        this.onPointerOut = (event) => {
          if (event.pointerType === 'touch') return;
          if (!this.contains(event.target)) return;
          if (this.contains(event.relatedTarget) || this.contains(document.activeElement)) return;
          this.clearTimers();
          this.closeTimer = window.setTimeout(() => this.hide(), 100);
        };
        this.onFocusIn = () => {
          this.clearTimers();
          this.show();
        };
        this.onFocusOut = (event) => {
          if (this.contains(event.relatedTarget) || this.matches(':hover')) return;
          this.clearTimers();
          this.closeTimer = window.setTimeout(() => this.hide(), 100);
        };

        this.addEventListener('pointerover', this.onPointerOver);
        this.addEventListener('pointerout', this.onPointerOut);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
      }

      document.addEventListener('pointerdown', this.onDocumentPointerDown);
      document.addEventListener('keydown', this.onKeyDown);
      window.addEventListener('resize', this.onDocumentPointerDown);
    }

    isOpen() {
      return !!this.panel && this.panel.matches(':popover-open');
    }

    markOpened(source) {
      this.openedAt = performance.now();
      this.openedByInterest = source === 'interest';
    }

    handleClick(event) {
      const trigger = event.target.closest('.ndev-tooltip__trigger');
      if (!trigger || !this.contains(trigger)) return;

      if (!this.isOpen()) {
        this.show('click');
        return;
      }

      // 由兴趣（hover / 焦点 / 长按）打开，且紧随其后的同一次点击：不关闭，避免触摸端闪一下就消失
      if (this.openedByInterest && performance.now() - this.openedAt < 400) return;

      this.hide();
    }

    clearTimers() {
      if (this.openTimer) window.clearTimeout(this.openTimer);
      if (this.closeTimer) window.clearTimeout(this.closeTimer);
      this.openTimer = null;
      this.closeTimer = null;
    }

    // 箭头朝向与横向位置：按面板与触发的实际位置判定（原生定位与脚本定位共用）。
    // 面板被视口挤压时不再居中于触发元素，箭头必须跟随触发元素，否则会指向面板中心。
    setPlacement() {
      if (!this.panel || !this.trigger) return;
      const panelRect = this.panel.getBoundingClientRect();
      const triggerRect = this.trigger.getBoundingClientRect();
      if (!panelRect.height || !triggerRect.height) return;
      this.panel.setAttribute('data-placement', panelRect.top >= triggerRect.top ? 'below' : 'above');

      const style = getComputedStyle(this.panel);
      const length = (name, fallback) => {
        const value = parseFloat(style.getPropertyValue(name));
        return Number.isFinite(value) ? value : fallback;
      };
      const arrowWidth = length('--ndev-tooltip-arrow-width', 20);
      const radius = length('--ndev-tooltip-radius', 8);
      const center = triggerRect.left + triggerRect.width / 2 - panelRect.left;
      const min = Math.min(radius + arrowWidth / 2, panelRect.width / 2);
      const max = Math.max(panelRect.width - radius - arrowWidth / 2, panelRect.width / 2);
      // 写在根元素：shape() 的 var() 在声明它的元素上就完成替换，写在面板上不会生效
      this.style.setProperty('--ndev-tooltip-arrow-x', Math.min(Math.max(center, min), max) + 'px');
    }

    place() {
      const triggerRect = this.trigger.getBoundingClientRect();
      const panelWidth = this.panel.offsetWidth;
      const panelHeight = this.panel.offsetHeight;
      const gap = this.gap();

      let top = triggerRect.top - panelHeight - gap;
      if (top < 8) {
        top = triggerRect.bottom + gap;
      }

      const maxLeft = window.innerWidth - panelWidth - 8;
      const centered = triggerRect.left + triggerRect.width / 2 - panelWidth / 2;
      const left = Math.max(8, Math.min(centered, Math.max(8, maxLeft)));

      this.panel.style.left = left + 'px';
      this.panel.style.top = top + 'px';
      this.panel.setAttribute('data-positioned', '');
      this.setPlacement();
    }

    gap() {
      if (!this.panel) return 6;
      const value = parseFloat(getComputedStyle(this.panel).getPropertyValue('--ndev-tooltip-gap'));
      return Number.isFinite(value) ? value : 6;
    }

    show(source = 'click') {
      if (!this.panel || !this.trigger || typeof this.panel.showPopover !== 'function') return;
      if (NdevTooltip.active === this) return;

      NdevTooltip.active?.hide();
      this.clearTimers();

      try {
        if (!this.isOpen()) this.panel.showPopover();
      } catch (error) {
        return;
      }

      NdevTooltip.active = this;
      this.markOpened(source);

      // 原生 interest 路径由浏览器定位，只需补方向；兜底路径需要自行定位
      if (this.supportsInterest) {
        window.requestAnimationFrame(() => this.setPlacement());
      } else {
        this.place();
      }
    }

    hide() {
      this.clearTimers();
      if (NdevTooltip.active === this) NdevTooltip.active = null;
      if (!this.panel) return;

      this.panel.style.left = '';
      this.panel.style.top = '';
      this.style.removeProperty('--ndev-tooltip-arrow-x');
      this.panel.removeAttribute('data-positioned');
      if (this.isOpen()) this.panel.hidePopover();
    }

    dispose() {
      this.removeEventListener('interest', this.onInterest, true);
      this.removeEventListener('click', this.onClick);
      this.clearTimers();
      this.hide();

      if (!this.supportsInterest) {
        this.removeEventListener('pointerover', this.onPointerOver);
        this.removeEventListener('pointerout', this.onPointerOut);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
      }

      document.removeEventListener('pointerdown', this.onDocumentPointerDown);
      document.removeEventListener('keydown', this.onKeyDown);
      window.removeEventListener('resize', this.onDocumentPointerDown);
    }
  }

  // 同页多实例互斥：模块作用域共享当前展开的实例
  NdevTooltip.active = null;

  if (!customElements.get('ndev-tooltip')) {
    customElements.define('ndev-tooltip', NdevTooltip);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-video-seek"] && !Shopify.designMode) return;
  try {
    (() => {
    const GUARD = '__ndevVideoSeek';
    const ROOT_ATTR = 'data-ndev-video-seek';

    if (!window[GUARD]) {
      window[GUARD] = {
        instances: new WeakMap(),
        rafId: null,
        pendingProgress: new Map(),

        loop() {
          const self = this;
          const entries = Array.from(this.pendingProgress.entries());

          entries.forEach(function(entry) {
            const el = entry[0];
            const progress = entry[1];
            const inst = self.instances.get(el);

            if (inst && inst.isActive && inst.video && inst.ready) {
              self.seekTo(inst, progress);
              self.emitProgress(el, progress, inst);
            }
          });

          this.pendingProgress.clear();
          this.rafId = null;
        },

        seekTo(inst, progress) {
          const { video, duration } = inst;
          if (!video) return;

          const targetTime = progress * duration;
          const timeDiff = Math.abs(video.currentTime - targetTime);

          // 只有当差异大于阈值且不在 seeking 状态时才 seek
          if (timeDiff > 0.05 && !video.seeking) {
            video.currentTime = targetTime;
          }
        },

        emitProgress(el, progress, inst) {
          const key = el;
          const lastProgress = this.pendingProgress.get(key) || -1;
          const currentProgress = Math.round(progress * 1000);

          if (currentProgress !== lastProgress) {
            this.pendingProgress.set(key, currentProgress);
            el.dispatchEvent(new CustomEvent('ndev-video-seek-progress', {
              detail: {
                progress: progress,
                percent: Math.round(progress * 100),
                currentTime: progress * inst.duration,
                duration: inst.duration
              },
              bubbles: true
            }));
          }
        },

        schedule(el, progress) {
          this.pendingProgress.set(el, progress);
          if (!this.rafId) {
            const self = this;
            this.rafId = requestAnimationFrame(function() { self.loop(); });
          }
        },

        init(options) {
          const self = this;
          const el = options.el;
          const wrap = el.querySelector('[data-ndev-vseek-wrap]');
          if (!wrap) return;

          const vhPerSecond = parseFloat(el.dataset.ndevVideoSeekVhPerSecond) || 100;
          const pcDuration = parseFloat(wrap.dataset.ndevVseekPcDuration) || 0;
          const mbDuration = parseFloat(wrap.dataset.ndevVseekMbDuration) || pcDuration;

          const isMobile = $narwal.isMobile;
          const duration = isMobile ? mbDuration : pcDuration;

          // 设置容器高度
          const heightVh = Math.ceil(duration * vhPerSecond);
          el.style.height = heightVh + 'vh';

          const inst = {
            el: el,
            wrap: wrap,
            video: null,
            duration: duration,
            ready: false,
            isActive: false
          };

          this.instances.set(el, inst);

          // 获取对应的 video 元素
          const videoClass = isMobile ? '.ndev-vseek__video.mb-done' : '.ndev-vseek__video.pc-done';
          const video = wrap.querySelector(videoClass);

          if (video) {
            function onReady() {
              inst.duration = video.duration;
              inst.ready = true;
              inst.video = video;

              // 触发 ready 事件
              el.dispatchEvent(new CustomEvent('ndev-video-seek-ready', {
                detail: { duration: inst.duration },
                bubbles: true
              }));

              // 初始 seek 到第一帧
              video.currentTime = 0;
            }

            // 处理竞态：视频可能已加载完成
            if (video.readyState >= 1) {
              onReady();
            } else {
              video.addEventListener('loadedmetadata', onReady);
            }

            video.addEventListener('error', function(e) {
              console.error('[ndev-vseek] Video error:', e);
            });
          }

          // 启动滚动监听
          $narwal.progress({ selectors: [el] }, function(progress) {
            inst.isActive = progress.enter;
            if (progress.enter) {
              self.schedule(el, progress.visualFps);
            }
          });
        }
      };
    }

    const initElements = function() {
      var elements = document.querySelectorAll('[' + ROOT_ATTR + ']');
      elements.forEach(function(el) {
        if (!window[GUARD].instances.has(el)) {
          var wrap = el.querySelector('[data-ndev-vseek-wrap]');
          if (wrap) {
            window[GUARD].init({ el: el });
          }
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initElements);
    } else {
      initElements();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ndev-youtube-media-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__ndevYoutubeMediaCardPlayerInited) return;
    window.__ndevYoutubeMediaCardPlayerInited = true;

    const mobileMQ = () => window.matchMedia && window.matchMedia('(max-width: 1023px)').matches;

    function getVideoEl(card, index) {
      const list = card.querySelectorAll(`[node-name="video_${index}"]`);
      if (!list || list.length === 0) return null;

      if (list.length === 1) {
        const one = list[0];
        return one.tagName === 'VIDEO' ? one : (one.querySelector('video') || null);
      }

      const mobile = mobileMQ();
      const pick = Array.from(list).find((el) =>
        mobile ? el.classList.contains('mobile-done') : el.classList.contains('pc-done')
      );
      const node = pick || list[0];
      return node.tagName === 'VIDEO' ? node : (node.querySelector('video') || null);
    }

    function getBar(card, index) {
      return card.querySelector(`[node-name="bar_${index}"]`) || null;
    }

    function setBarProgress(bar, ratio) {
      if (!bar) return;
      const clamped = Math.max(0, Math.min(1, ratio));
      const total = 301.44;
      bar.style.strokeDashoffset = String(total * (1 - clamped));
    }

    function toggleIcons(card, index, isPlaying) {
      const playIcon = card.querySelector(`[node-name="play_${index}"]`);
      const pauseIcon = card.querySelector(`[node-name="pause_${index}"]`);
      if (playIcon) playIcon.classList.toggle('hide', isPlaying);
      if (pauseIcon) pauseIcon.classList.toggle('hide', !isPlaying);
    }

    function playVideo(card, index) {
      const video = getVideoEl(card, index);
      if (!video) return;
      card.classList.add('off');
      toggleIcons(card, index, true);

      try {
        const p = video.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      } catch (_) {}
    }

    function pauseVideo(card, index) {
      const video = getVideoEl(card, index);
      if (!video) return;
      try {
        video.pause();
      } catch (_) {}
      card.classList.remove('off');
      toggleIcons(card, index, false);
    }

    function playEmbed(card, index) {
      const codeEl = card.querySelector('[data-ndev-youtube-embed-code]');
      const wrap = card.querySelector('[data-ndev-youtube-embed]');
      if (!codeEl || !wrap) return;

      let code = '';
      try {
        code = JSON.parse(codeEl.textContent || '""') || '';
      } catch (_) {
        code = '';
      }
      if (!code) return;

      wrap.innerHTML = code;
      const iframe = wrap.querySelector('iframe');
      if (!iframe) return;
      const rawSrc = iframe.getAttribute('src') || iframe.getAttribute('data-src') || '';
      if (!rawSrc) return;
      iframe.setAttribute('allow', iframe.getAttribute('allow') || 'autoplay; encrypted-media; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.removeAttribute('data-src');

      const urlChar = rawSrc.includes('?') ? '&' : '?';
      iframe.setAttribute('src', `${rawSrc}${urlChar}autoplay=1&v=${Date.now()}`);
      card.classList.add('off');
    }

    document.addEventListener('click', (ev) => {
      const btn = ev.target && ev.target.closest && ev.target.closest('[node-name="play"]');
      if (!btn) return;

      const card = btn.closest('[data-ndev-youtube-media-card]');
      if (!card) return;

      ev.stopPropagation();
      const index = Number(btn.dataset.index || 0);

      if (btn.dataset.type === 'embed') {
        playEmbed(card, index);
        return;
      }

      // video toggle
      const video = getVideoEl(card, index);
      if (!video) return;
      if (!video.paused) pauseVideo(card, index);
      else playVideo(card, index);
    });

    document.addEventListener('timeupdate', (ev) => {
      const video = ev.target;
      if (!video || video.tagName !== 'VIDEO') return;

      const card = video.closest && video.closest('[data-ndev-youtube-media-card]');
      if (!card) return;

      const index = Number(card.querySelector('[node-name="play"]')?.dataset?.index || 0);
      const bar = getBar(card, index);
      const ratio = video.duration ? (video.currentTime / video.duration) : 0;
      setBarProgress(bar, ratio);
    }, true);

    // 播放结束时复位 UI
    document.addEventListener('ended', (ev) => {
      const video = ev.target;
      if (!video || video.tagName !== 'VIDEO') return;
      const card = video.closest && video.closest('[data-ndev-youtube-media-card]');
      if (!card) return;
      const index = Number(card.querySelector('[node-name="play"]')?.dataset?.index || 0);
      const bar = getBar(card, index);
      card.classList.remove('off');
      toggleIcons(card, index, false);
      setBarProgress(bar, 0);
      try {
        video.currentTime = 0;
      } catch (_) {}
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-buy-box-benefits-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-benefits-modal')) {
    class ProductBuyBoxBenefitsModal extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');
        this._sourceId = this.getAttribute('source-id');
        this._dialog = this.querySelector('[role="dialog"]');
        this._single = this.querySelector('[data-benefits-single]');
        this._slider = this.querySelector('[data-benefits-slider]');
        this._slides = this.querySelector('[data-benefits-slides]');
        this._currentEl = this.querySelector('[data-benefits-current]');
        this._totalEl = this.querySelector('[data-benefits-total]');
        this._prevBtn = this.querySelector('[data-benefits-prev]');
        this._nextBtn = this.querySelector('[data-benefits-next]');
        this._progressEl = this.querySelector('.product-buy-box-benefits-modal__progress');
        this._pagination = this.classList.contains('is-pagination');
        this._autoplayDelay = parseInt(this.getAttribute('autoplay-delay'), 10) || 3000;
        this._templates = [];
        this._swiper = null;
        this._progressTimer = null;
        this._slidesBuilt = false;
        this._closeTimer = null;
        this._openFrame = null;

        this._onOpen = (event) => this._handleOpen(event.detail || {});
        this._onCloseClick = (event) => {
          if (event.target.closest('[data-modal-close]')) this.close();
        };
        this._onKeydown = (event) => this._handleKeydown(event);
        this._onPrev = () => this._swiper?.slidePrev();
        this._onNext = () => this._swiper?.slideNext();

        this._root?.addEventListener('product-buy-box:benefits-modal-open', this._onOpen);
        this.addEventListener('click', this._onCloseClick);
        this._prevBtn?.addEventListener('click', this._onPrev);
        this._nextBtn?.addEventListener('click', this._onNext);
      }

      dispose() {
        this._root?.removeEventListener('product-buy-box:benefits-modal-open', this._onOpen);
        this.removeEventListener('click', this._onCloseClick);
        this._prevBtn?.removeEventListener('click', this._onPrev);
        this._nextBtn?.removeEventListener('click', this._onNext);
        document.removeEventListener('keydown', this._onKeydown);
        this._stopAutoplay();
        this._root = null;
      }

      _handleOpen(detail) {
        if (detail.sourceId !== this._sourceId) return;
        this._refreshTemplates();
        if (!this._templates.length) return;

        const key = detail.benefitKey || this._templates[0].key;
        const index = Math.max(0, this._templates.findIndex((item) => item.key === key));

        if (this._pagination && window.Swiper && this._templates.length > 1) {
          this._openSlider(index);
        } else {
          this._openSingle(index);
        }

        this._previousActiveElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        clearTimeout(this._closeTimer);
        if (this._openFrame) cancelAnimationFrame(this._openFrame);
        this.hidden = false;
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this._onKeydown);
        this._openFrame = requestAnimationFrame(() => {
          this.classList.add('is-visible');
          this._dialog?.focus();
          this._openFrame = null;
        });
      }

      close() {
        if (this.hidden) return;
        if (this._openFrame) {
          cancelAnimationFrame(this._openFrame);
          this._openFrame = null;
        }
        this.classList.remove('is-visible');
        this._stopAutoplay();
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this._onKeydown);
        if (this._previousActiveElement?.isConnected) this._previousActiveElement.focus();
        this._previousActiveElement = null;
        clearTimeout(this._closeTimer);
        this._closeTimer = setTimeout(() => {
          this.hidden = true;
          if (this._single) this._single.innerHTML = '';
          this._closeTimer = null;
        }, this._isMobile() ? 300 : 500);
      }

      _refreshTemplates() {
        const source = document.getElementById(this._sourceId);
        const templates = source ? source.querySelectorAll('[data-pbb-benefit-modal-template]') : [];
        this._templates = [...templates].map((template) => ({
          key: template.getAttribute('data-benefit-key') || '',
          html: template.innerHTML
        })).filter((item) => item.key && item.html.trim());
      }

      _openSingle(index) {
        if (this._single) {
          this._single.hidden = false;
          this._single.innerHTML = this._templates.map((item) => (
            `<div class="product-buy-box-benefits-modal__item" data-benefit-key="${this._escapeAttr(item.key)}">${item.html}</div>`
          )).join('');
          const target = [...this._single.querySelectorAll('[data-benefit-key]')]
            .find((item) => item.getAttribute('data-benefit-key') === this._templates[index].key);
          if (target) {
            setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }), this._isMobile() ? 350 : 100);
          }
        }
        if (this._slider) this._slider.hidden = true;
      }

      _openSlider(index) {
        if (this._single) this._single.hidden = true;
        if (this._slider) this._slider.hidden = false;
        this._buildSlides();

        if (!this._swiper) {
          this._swiper = new window.Swiper(this._slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            pagination: {
              el: this.querySelector('[data-benefits-pagination]'),
              clickable: true
            },
            on: {
              slideChange: () => {
                this._updatePagination(this._swiper.realIndex || 0);
                this._restartAutoplay();
              }
            }
          });
        }

        this._swiper.slideToLoop(index, this._isMobile() ? 350 : 100);
        this._updatePagination(index);
        this._restartAutoplay();
      }

      _buildSlides() {
        if (this._slidesBuilt || !this._slides) return;
        this._slides.innerHTML = this._templates.map((item) => (
          `<div class="swiper-slide"><div class="product-buy-box-benefits-modal__item" data-benefit-key="${this._escapeAttr(item.key)}">${item.html}</div></div>`
        )).join('');
        this._slidesBuilt = true;
        if (this._totalEl) this._totalEl.textContent = this._formatPage(this._templates.length);
      }

      _updatePagination(index) {
        if (this._currentEl) this._currentEl.textContent = this._formatPage(index + 1);
      }

      _restartAutoplay() {
        this._stopAutoplay();
        if (this._isMobile() || !this._swiper || !this._progressEl) return;

        const circumference = 2 * Math.PI * 9.6;
        let progress = 0;
        const updateInterval = 50;
        const stepSize = 100 / (this._autoplayDelay / updateInterval);

        this._progressEl.style.strokeDasharray = circumference;
        this._progressEl.style.strokeDashoffset = circumference;

        this._progressTimer = setInterval(() => {
          progress += stepSize;
          const nextOffset = circumference - (Math.min(progress, 100) / 100) * circumference;
          this._progressEl.style.strokeDashoffset = nextOffset;

          if (progress >= 100) {
            this._stopAutoplay();
            this._swiper?.slideNext();
          }
        }, updateInterval);
      }

      _stopAutoplay() {
        clearInterval(this._progressTimer);
        this._progressTimer = null;
        if (this._progressEl) {
          this._progressEl.style.strokeDashoffset = 60.32;
        }
      }

      _handleKeydown(event) {
        if (this.hidden) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;

        const focusable = [...this.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
          .filter((el) => el.offsetParent !== null);
        if (!focusable.length) {
          event.preventDefault();
          this._dialog?.focus();
          return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (document.activeElement === this._dialog) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      _formatPage(value) {
        return value < 10 ? `0${value}` : String(value);
      }

      _isMobile() {
        return window.matchMedia('(max-width: 768px)').matches;
      }

      _escapeAttr(value) {
        return String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      }
    }

    customElements.define('product-buy-box-benefits-modal', ProductBuyBoxBenefitsModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-buy-box-preview-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-preview-modal')) {
    class ProductBuyBoxPreviewModal extends BaseElement {
      init() {
        this._content = this.querySelector('[data-preview-content]');
        this._dialog = this.querySelector('[role="dialog"]');
        this._onOpen = (e) => this.open(e.detail || {});
        this._onCloseClick = (e) => {
          if (e.target.matches('[data-preview-close]')) this.close();
        };
        this._onKeyDown = (e) => this._handleKeyDown(e);

        this.closest('product-buy-box')?.addEventListener('product-buy-box:media-preview-open', this._onOpen);
        this.addEventListener('click', this._onCloseClick);
      }

      dispose() {
        this.closest('product-buy-box')?.removeEventListener('product-buy-box:media-preview-open', this._onOpen);
        this.removeEventListener('click', this._onCloseClick);
        document.removeEventListener('keydown', this._onKeyDown);
      }

      open(detail) {
        if (!this._content) return;
        while (this._content.firstChild) this._content.removeChild(this._content.firstChild);
        if (detail.content instanceof Node) {
          this._content.appendChild(detail.content);
        }
        this._previousActiveElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        this.hidden = false;
        document.addEventListener('keydown', this._onKeyDown);
        this._focusFirstElement();
      }

      close() {
        if (this.hidden) return;
        this.hidden = true;
        document.removeEventListener('keydown', this._onKeyDown);
        if (this._previousActiveElement?.isConnected) this._previousActiveElement.focus();
        this._previousActiveElement = null;
      }

      _focusableElements() {
        return [...this.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
          .filter((el) => el.offsetParent !== null);
      }

      _focusFirstElement() {
        this._dialog?.focus();
      }

      _handleKeyDown(e) {
        if (this.hidden) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          this.close();
          return;
        }
        if (e.key !== 'Tab') return;

        const focusable = this._focusableElements();
        if (!focusable.length) {
          e.preventDefault();
          this._dialog?.focus();
          return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (document.activeElement === this._dialog) {
          e.preventDefault();
          (e.shiftKey ? last : first).focus();
        } else if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    customElements.define('product-buy-box-preview-modal', ProductBuyBoxPreviewModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-buy-box-promo-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-promo-modal')) {
    class ProductBuyBoxPromoModal extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');
        this._dialog = this.querySelector('[role="dialog"]');
        this._titleEl = this.querySelector('[data-modal-title]');
        this._contentEl = this.querySelector('[data-modal-content]');
        this._currentVariantId = this.getAttribute('current-variant-id') || '';
        this._fallbackTitle = this.getAttribute('fallback-title') || '';
        this._fallbackContent = this._contentEl ? this._contentEl.innerHTML : '';

        const jsonEl = this.querySelector('[data-promo-help-variants]');
        this._variantMap = jsonEl ? JSON.parse(jsonEl.textContent) : {};

        this._onOpen = () => this.open();
        this._onVariantChange = (e) => {
          const detail = e.detail || {};
          if (detail.variantId) this._currentVariantId = String(detail.variantId);
        };
        this._onCloseClick = (e) => {
          if (e.target.matches('[data-modal-close]')) this.close();
        };
        this._onKeyDown = (e) => this._handleKeyDown(e);

        this._root?.addEventListener('product-buy-box:promo-help-open', this._onOpen);
        this._root?.addEventListener('product-buy-box:variant-change', this._onVariantChange);
        this.addEventListener('click', this._onCloseClick);
      }

      dispose() {
        this._root?.removeEventListener('product-buy-box:promo-help-open', this._onOpen);
        this._root?.removeEventListener('product-buy-box:variant-change', this._onVariantChange);
        this.removeEventListener('click', this._onCloseClick);
        document.removeEventListener('keydown', this._onKeyDown);
        this._root = null;
      }

      open() {
        const content = this._variantMap[this._currentVariantId] || {};
        const title = content.title || this._fallbackTitle;
        const body = content.content || this._fallbackContent;

        if (!body) return;
        if (this._titleEl) {
          this._titleEl.textContent = title;
          this._titleEl.hidden = !title;
        }
        if (this._contentEl) {
          this._contentEl.innerHTML = body;
        }
        this._previousActiveElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        this.hidden = false;
        document.addEventListener('keydown', this._onKeyDown);
        this._focusFirstElement();
      }

      close() {
        if (this.hidden) return;
        this.hidden = true;
        document.removeEventListener('keydown', this._onKeyDown);
        if (this._previousActiveElement?.isConnected) this._previousActiveElement.focus();
        this._previousActiveElement = null;
      }

      _focusableElements() {
        return [...this.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
          .filter((el) => el.offsetParent !== null);
      }

      _focusFirstElement() {
        this._dialog?.focus();
      }

      _handleKeyDown(e) {
        if (this.hidden) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          this.close();
          return;
        }
        if (e.key !== 'Tab') return;

        const focusable = this._focusableElements();
        if (!focusable.length) {
          e.preventDefault();
          this._dialog?.focus();
          return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (document.activeElement === this._dialog) {
          e.preventDefault();
          (e.shiftKey ? last : first).focus();
        } else if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    customElements.define('product-buy-box-promo-modal', ProductBuyBoxPromoModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shopify-editor-hmr"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var registered = false;

    function inEditor() {
      return document.designMode === 'on';
    }

    /** `root` 子树内所有 `[data-hmr]`，文档序；根自身若匹配则在最前 */
    function listHmrUnder(root) {
      if (!root || root.nodeType !== 1) return [];
      var out = [];
      if (root.matches && root.matches('[data-hmr]')) out.push(root);
      var n = root.querySelectorAll('[data-hmr]');
      for (var i = 0; i < n.length; i++) out.push(n[i]);
      return out;
    }

    /** `reverse`：仅给 `__dispose__` 用，先子后父 */
    function invoke(list, key, reverse) {
      var len = list.length;
      var step = reverse ? -1 : 1;
      var i = reverse ? len - 1 : 0;
      var end = reverse ? -1 : len;
      for (; i !== end; i += step) {
        var el = list[i];
        var fn = el[key];
        if (typeof fn !== 'function') continue;
        try {
          fn.call(el);
        } catch (e) {
          console.warn('[hmr] ' + key, el, e);
        }
      }
    }

    function onSection(event, unload) {
      invoke(listHmrUnder(event.target), unload ? '__dispose__' : '__hmr__', unload);
    }

    function bind() {
      if (!inEditor() || registered) return;
      registered = true;
      document.addEventListener('shopify:section:load', function (e) {
        onSection(e, false);
      });
      document.addEventListener('shopify:section:unload', function (e) {
        onSection(e, true);
      });
    }

    function boot() {
      if (!inEditor()) return;
      invoke(document.querySelectorAll('[data-hmr]'), '__hmr__', false);
      bind();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
